(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(2818);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ ArticleCardList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Cards/ArticleCard.tsx + 2 modules
var ArticleCard = __webpack_require__(8934);
// EXTERNAL MODULE: ./node_modules/@themuse/snowplow-js-client/build/index.js
var build = __webpack_require__(8580);
// EXTERNAL MODULE: ./src/hooks/AppContext.tsx + 2 modules
var AppContext = __webpack_require__(6369);
// EXTERNAL MODULE: ./src/utils/api.ts + 1 modules
var api = __webpack_require__(6366);
// EXTERNAL MODULE: ./src/components/ArticleCardList.module.scss
var ArticleCardList_module = __webpack_require__(8468);
var ArticleCardList_module_default = /*#__PURE__*/__webpack_require__.n(ArticleCardList_module);
;// CONCATENATED MODULE: ./src/components/ArticleCardList.utils.ts
/* eslint-disable camelcase */ 
const getSponsorLogo = (path)=>{
    if (!path) {
        return "";
    }
    const { publicRuntimeConfig: { pilboxHost , staticCmsAssetHost  }  } = (0,config["default"])();
    const resized = new URL(pilboxHost);
    resized.search = new URLSearchParams({
        url: `${staticCmsAssetHost}/${path}`,
        w: "202",
        filter: "antialias",
        mode: "fill",
        background: "fff",
        opt: "1",
        prog: "1",
        q: "keep"
    }).toString();
    return resized.toString();
};
const getAuthorLogo = (path)=>{
    if (!path) {
        return "";
    }
    const { publicRuntimeConfig: { pilboxHost  }  } = (0,config["default"])();
    const resized = new URL(pilboxHost);
    resized.search = new URLSearchParams({
        url: path,
        h: "120",
        w: "120",
        filter: "antialias",
        mode: "crop",
        pos: "top",
        opt: "1",
        prog: "1",
        q: "keep"
    }).toString();
    return resized.toString();
};
const getLogoSrc = ({ sponsor , writer  })=>{
    if (sponsor?.id) {
        return getSponsorLogo(sponsor?.logoImage);
    }
    return getAuthorLogo(writer?.headshot?.url);
};
const getBaseSnowplowProps = ({ articleId , companyId , tileOrder , trackingLocation  })=>({
        sp_tile_company_id: companyId,
        sp_tile_entity_id: articleId,
        sp_tile_location: trackingLocation,
        sp_tile_order: tileOrder,
        sp_tile_type: "article"
    });
const getImpressionProps = (props)=>{
    const { trackingLocation  } = props;
    if (!trackingLocation) {
        return {};
    }
    const baseProps = getBaseSnowplowProps(props);
    return {
        "data-tracking-event-type": "impression",
        "data-tracking-props": JSON.stringify({
            ...baseProps,
            sp_impression_component: "tile",
            sp_impression_position: "main",
            sp_impression_tile_type: "article"
        })
    };
};
const getClickEventProps = (props)=>{
    const { linkText , ...restProps } = props;
    const { trackingLocation  } = props;
    const baseProps = getBaseSnowplowProps(restProps);
    return {
        ...baseProps,
        sp_click_component: "tile",
        sp_click_component_tile_type: "article",
        sp_click_link_text: linkText || null,
        sp_click_position: trackingLocation,
        sp_click_target_page_section: "profile"
    };
};

;// CONCATENATED MODULE: ./src/components/ArticleCardList.tsx

/* eslint-disable camelcase */ 







const ArticleCardList = (props)=>{
    const { size , title , trackingLocation , viewMore , ...restProps } = props;
    const { publicRuntimeConfig: { museWebHost  }  } = (0,config["default"])();
    const { company: { legacy_id: companyId , short_name  }  } = (0,AppContext/* useAppState */.mr)();
    const { 0: articles , 1: setArticles  } = (0,react.useState)([]);
    const { 0: showMore , 1: setShowMore  } = (0,react.useState)(false);
    const wrapper = (0,react.useRef)();
    const handleCardClick = (trackingData)=>{
        if (!trackingData.trackingLocation) {
            return;
        }
        const clickEventProps = getClickEventProps(trackingData);
        (0,build.triggerSnowplowClickEvent)(clickEventProps);
    };
    (0,react.useEffect)(()=>{
        (0,api/* fetchArticles */.Zt)({
            company_short_name: short_name,
            size: String(size || 100)
        }).then((result)=>{
            setArticles(result?.articles?.data ?? []);
            setShowMore(result?.pagination?.totalPages > 1);
        }).catch((error)=>{
            console.error(error);
        });
    }, [
        short_name,
        size
    ]);
    (0,react.useEffect)(()=>{
        if (articles?.length) {
            (0,build.trackSnowplowImpressions)(wrapper.current || undefined);
        }
    }, [
        !!articles?.length
    ]);
    return articles?.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        ...restProps,
        ref: wrapper,
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (ArticleCardList_module_default()).heading,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ArticleCardList_module_default()).cardList,
                children: articles.map((article, i)=>{
                    const { companySponsor: sponsor , legacyId , writer  } = article;
                    const logoSrc = getLogoSrc({
                        sponsor,
                        writer
                    });
                    const trackingData = {
                        articleId: legacyId?.toString(),
                        companyId: companyId?.toString(),
                        tileOrder: i + 1,
                        trackingLocation
                    };
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCard/* ArticleCard */.T, {
                        author: sponsor?.title ?? writer?.writerName,
                        category: article.primaryTopic?.title,
                        categoryUrl: article.primaryTopic?.slug && `${museWebHost}/advice/${article.primaryTopic?.slug}`,
                        contentUrl: `${museWebHost}/${article.uri}`,
                        imgSrc: article.leadMediaPhoto?.url,
                        logoSrc: logoSrc,
                        onCardClick: ()=>handleCardClick(trackingData),
                        sponsorId: sponsor?.id,
                        title: article.title,
                        ...getImpressionProps(trackingData)
                    }, article.id);
                })
            }),
            showMore && viewMore || null
        ]
    }) : null;
};


/***/ }),

/***/ 3346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J": function() { return /* reexport */ EmployeeCard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/utils/strings.ts
var strings = __webpack_require__(2918);
// EXTERNAL MODULE: ./src/components/EmployeeCard/EmployeeCard.module.scss
var EmployeeCard_module = __webpack_require__(38);
var EmployeeCard_module_default = /*#__PURE__*/__webpack_require__.n(EmployeeCard_module);
// EXTERNAL MODULE: ./src/components/EmployeeCard/Featured.module.scss
var Featured_module = __webpack_require__(9947);
var Featured_module_default = /*#__PURE__*/__webpack_require__.n(Featured_module);
;// CONCATENATED MODULE: ./src/components/EmployeeCard/Featured.tsx

/* eslint-disable camelcase */ 



const Featured = ({ className , employee , layout , onClick , ...props })=>{
    const { description , first_name , employee_photo , job_title , last_name , quote1 ,  } = employee;
    const title = (0,strings/* joinExisting */.z_)([
        first_name,
        last_name
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        className: classnames_default()((Featured_module_default()).wrapper, {
            [(Featured_module_default())["wrapper--reverse"]]: layout === "featured-left"
        }, className),
        ...props,
        children: [
            !!employee_photo && /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                className: classnames_default()((EmployeeCard_module_default()).figure, (Featured_module_default()).figure),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        "aria-hidden": true,
                        className: classnames_default()((Featured_module_default()).leaf, {
                            [(Featured_module_default())["leaf--flipped"]]: layout === "featured-right"
                        }),
                        fill: "none",
                        height: "148",
                        role: "presentation",
                        viewBox: "0 0 116 148",
                        width: "116",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M 24.087 46.407 C 31.673 14.15 63.972 -5.851 96.229 1.735 L 151.036 14.623 C 159.638 16.646 164.972 25.259 162.949 33.861 L 139.524 133.474 C 131.939 165.731 99.64 185.731 67.383 178.146 L 12.575 165.257 C 3.973 163.234 -1.36 154.621 0.663 146.02 L 24.087 46.407 Z",
                            fill: "currentColor"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: (EmployeeCard_module_default()).image,
                        src: employee_photo,
                        alt: title,
                        loading: "lazy"
                    }),
                    !!onClick && /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                        className: (EmployeeCard_module_default()).figcap,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: classnames_default()((EmployeeCard_module_default()).cta, (Featured_module_default()).cta),
                            onClick: onClick,
                            type: "button",
                            children: "Learn More"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Featured_module_default()).body,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: (EmployeeCard_module_default()).title,
                        children: title
                    }),
                    !!job_title && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (EmployeeCard_module_default()).subheading,
                        children: job_title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (EmployeeCard_module_default()).description,
                        children: description
                    }),
                    !!quote1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (Featured_module_default()).quote,
                        children: quote1
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/EmployeeCard/Hero.module.scss
var Hero_module = __webpack_require__(1951);
var Hero_module_default = /*#__PURE__*/__webpack_require__.n(Hero_module);
;// CONCATENATED MODULE: ./src/components/EmployeeCard/Hero.tsx

/* eslint-disable camelcase */ 




const Hero = ({ className , employee , onClick , ...props })=>{
    const { description , first_name , employee_photo , job_title , last_name ,  } = employee;
    const title = (0,strings/* joinExisting */.z_)([
        first_name,
        last_name
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        className: classnames_default()((Hero_module_default()).wrapper, className),
        ...props,
        style: {
            "--bg-img": `url(${employee_photo})`
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Hero_module_default()).body,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: (Hero_module_default()).title,
                        children: title
                    }),
                    !!job_title && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: classnames_default()((EmployeeCard_module_default()).subheading, (Hero_module_default()).subheading),
                        children: job_title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: classnames_default()((EmployeeCard_module_default()).description, (Hero_module_default()).description),
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: classnames_default()((EmployeeCard_module_default()).cta, (Hero_module_default()).cta),
                onClick: onClick,
                type: "button",
                children: "Learn More"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/EmployeeCard/Standard.tsx

/* eslint-disable camelcase */ 

const Standard = ({ employee , onClick , ...props })=>{
    const { description , first_name , employee_photo , job_title , last_name ,  } = employee;
    const title = (0,strings/* joinExisting */.z_)([
        first_name,
        last_name
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        ...props,
        children: [
            !!employee_photo && /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                className: (EmployeeCard_module_default()).figure,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: (EmployeeCard_module_default()).image,
                        src: employee_photo,
                        alt: title,
                        loading: "lazy"
                    }),
                    !!onClick && /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                        className: (EmployeeCard_module_default()).figcap,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: (EmployeeCard_module_default()).cta,
                            onClick: onClick,
                            type: "button",
                            children: "Learn More"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                className: (EmployeeCard_module_default()).header,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: (EmployeeCard_module_default()).title,
                        children: title
                    }),
                    !!job_title && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (EmployeeCard_module_default()).subheading,
                        children: job_title
                    })
                ]
            }),
            !!description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (EmployeeCard_module_default()).description,
                children: description
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/EmployeeCard/EmployeeCard.tsx





const EmployeeCard = (props)=>{
    switch(props.layout){
        case "featured-left":
        case "featured-right":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Featured, {
                ...props
            });
        case "hero":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero, {
                ...props
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Standard, {
                ...props
            });
    }
};

;// CONCATENATED MODULE: ./src/components/EmployeeCard/index.ts



/***/ }),

/***/ 3543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ EmployeeStoryModal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _themuse_design_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2869);
/* harmony import */ var _EmployeeStoryModal_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17);
/* harmony import */ var _EmployeeStoryModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_EmployeeStoryModal_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const EmployeeStoryModal = ({ employee , isOpen , setIsOpen  })=>{
    const { fullName , quotes  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>({
            fullName: [
                employee?.first_name,
                employee?.last_name
            ].filter(Boolean).join(" "),
            quotes: Array.from({
                length: 3
            }).reduce((accum, current, i)=>{
                const str = employee && employee[`quote${i + 1}`];
                if (str) {
                    accum.push({
                        key: `${employee.id}_quote${i + 1}`,
                        text: str.trim().replace(/^["'“”‘’]|["'“”‘’]$/g, "")
                    });
                }
                return accum;
            }, [])
        }), [
        employee?.id
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_themuse_design_system__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        closeButtonClassName: (_EmployeeStoryModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().modalClose),
        containerClassName: (_EmployeeStoryModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().dialog),
        contentClassName: (_EmployeeStoryModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().modalContent),
        isOpen: isOpen,
        setIsOpen: setIsOpen,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
                className: (_EmployeeStoryModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().header),
                children: [
                    !!employee?.employee_photo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_EmployeeStoryModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().portrait),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                alt: fullName,
                                className: (_EmployeeStoryModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().portraitImg),
                                loading: "lazy",
                                src: employee?.employee_photo
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                className: (_EmployeeStoryModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().portraitGraphic),
                                height: "40",
                                viewBox: "0 0 42 40",
                                width: "42",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        d: "M -160.5 20.5 L 32 20.5 C 141 20.6 228.5 -67.5 228.5 -175.5 L 229 -302.5",
                                        stroke: "currentColor"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        d: "M 20 39.5 C 20.5 34.5 23 30 26.5 26.5 C 30 23 35 21 40 21 C 34.5 20.5 29.5 18.5 26 14.5 C 22 10.5 20 5.5 20 0 C 20 5.5 18 11 14 15 C 10 18.5 5 21 -0.5 21 C 5 21 9.5 23 13.5 26 C 17 30 19.5 34.5 20 39.5 Z",
                                        fill: "currentColor"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_EmployeeStoryModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().headerContent),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: (_EmployeeStoryModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().title),
                                children: fullName
                            }),
                            !!employee?.job_title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: (_EmployeeStoryModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().subheading),
                                children: employee?.job_title
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_EmployeeStoryModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().mainBody),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                        className: (_EmployeeStoryModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().overviewTitle),
                        children: [
                            employee?.first_name,
                            "'s Story"
                        ]
                    }),
                    !!employee?.description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: (_EmployeeStoryModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().overviewText),
                        children: employee?.description
                    }),
                    quotes.map(({ key , text  })=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("blockquote", {
                            className: (_EmployeeStoryModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().quote),
                            children: text
                        }, key))
                ]
            })
        ]
    });
};


/***/ }),

/***/ 65:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ FeatureFlagsProvider; },
  "n": function() { return /* binding */ useFeatureFlagsState; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
;// CONCATENATED MODULE: ./src/utils/featureFlags.ts


/**
 * Take a name and determine if the feature flag is activated
 * based on environment variable and query params.
 */ const isFeatureFlagActive = (name, query, config)=>{
    if (name in query) {
        return isTruthy(query[name]);
    }
    if (config?.[name] !== undefined) {
        return config?.[name] === true || config?.[name] === "true";
    }
    return false;
};
/**
 * Returns a list of all existing flags in the config.
 */ const getFeatureFlags = ()=>{
    const { publicRuntimeConfig  } = (0,config["default"])();
    return Object.keys(publicRuntimeConfig).reduce((prev, curr)=>{
        if (/^FEATURE_FLAG/.test(curr)) {
            prev.push(curr);
        }
        return prev;
    }, []);
};
/**
 * Returns all active flags in the config and/or query params.
 */ const getActiveFeatureFlags = (context)=>{
    const { query  } = context;
    const { publicRuntimeConfig  } = getConfig();
    const featureFlagsInQuery = getFeatureFlags().reduce((featureFlags, featureFlag)=>({
            ...featureFlags,
            [featureFlag]: isFeatureFlagActive(featureFlag, query, publicRuntimeConfig)
        }), {});
    return featureFlagsInQuery;
};


;// CONCATENATED MODULE: ./src/hooks/FeatureFlagsContext.tsx



const defaultFeatureFlagsState = Object.keys(getFeatureFlags()).reduce((featureFlags, featureFlag)=>({
        ...featureFlags,
        [featureFlag]: false
    }), {});
const FeatureFlagsContext = /*#__PURE__*/ react.createContext(defaultFeatureFlagsState);
const FeatureFlagsProvider = (props)=>{
    const { featureFlags , children  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureFlagsContext.Provider, {
        value: featureFlags,
        children: children
    });
};
const useFeatureFlagsState = ()=>{
    const context = react.useContext(FeatureFlagsContext);
    if (context === undefined) {
        throw new Error("useFeatureFlagsState must be used within the FeatureFlagsProvider");
    }
    return context;
};
FeatureFlagsProvider.displayName = "FeatureFlagsProvider";
useFeatureFlagsState.displayName = "useFeatureFlagsState";



/***/ }),

/***/ 9696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ useEmployeeModal; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

const useEmployeeModal = ({ employeeStories  })=>{
    const { 0: modalOpen , 1: setIsOpen  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const { 0: openStoryId , 1: setOpenStoryId  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    const openStory = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>openStoryId && (employeeStories || []).find(({ id  })=>id === openStoryId), [
        employeeStories,
        openStoryId
    ]);
    const setOpenStory = (id)=>{
        setOpenStoryId(id);
        setIsOpen(true);
    };
    return {
        isOpen: !!openStory && modalOpen,
        openStory,
        setIsOpen,
        setOpenStory,
        setOpenStoryId
    };
};


/***/ }),

/***/ 2818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
// EXTERNAL MODULE: ./src/hooks/AppContext.tsx + 2 modules
var AppContext = __webpack_require__(6369);
// EXTERNAL MODULE: ./src/reducers/userReducer.ts
var userReducer = __webpack_require__(8112);
;// CONCATENATED MODULE: ./src/hooks/UserContext.tsx



const defaultUserState = {
    isInitialized: false,
    logged_in: false,
    view_bookings: false,
    company: null,
    location: null,
    cropped_name: "",
    email: "",
    favorite_posts: [],
    name: "",
    id: null
};
const UserStateContext = /*#__PURE__*/ react.createContext(defaultUserState);
const UserDispatchContext = /*#__PURE__*/ react.createContext(undefined);
/**
 * App Context Provider
 *
 * How to use:
 *
 * Wrap the provider around the components that need access to the context data.
 * ```
 * <UserProvider>
 *   <Component />
 * </UserProvider>
 * ```
 * Access the state in <Component />
 * ```
 * const state = useUserState();
 * ```
 * Call dispatch to update the context state
 * ```
 * const dispatch = useUserDispatch();
 * dispatch({ type: ACTION_TYPE, payload: ACTION_PAYLOAD });
 * ```
 */ const UserProvider = (props)=>{
    const { children  } = props;
    const [appState, dispatch] = react.useReducer(userReducer/* userReducer */.M, {
        ...defaultUserState
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserStateContext.Provider, {
        value: appState,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserDispatchContext.Provider, {
            value: dispatch,
            children: children
        })
    });
};
const useUserState = ()=>{
    const context = react.useContext(UserStateContext);
    if (context === undefined) {
        throw new Error("useUserState must be used within the UserProvider");
    }
    return context;
};
const useUserDispatch = ()=>{
    const context = react.useContext(UserDispatchContext);
    if (context === undefined) {
        throw new Error("useUserDispatch must be used within the UserProvider");
    }
    return context;
};
UserProvider.displayName = "UserProvider";
useUserState.displayName = "useUserState";
useUserDispatch.displayName = "useUserDispatch";


// EXTERNAL MODULE: ./src/hooks/FeatureFlagsContext.tsx + 1 modules
var FeatureFlagsContext = __webpack_require__(65);
// EXTERNAL MODULE: ./node_modules/@themuse/snowplow-js-client/build/index.js
var build = __webpack_require__(8580);
// EXTERNAL MODULE: ./src/utils/browser.ts
var browser = __webpack_require__(7228);
// EXTERNAL MODULE: ./src/utils/logging.ts
var logging = __webpack_require__(4453);
;// CONCATENATED MODULE: ./src/utils/tracking.tsx

/* eslint-disable camelcase */ /* eslint-disable @typescript-eslint/no-unused-vars */ 







const getAppVersion = ()=>{
    const { publicRuntimeConfig: { appVersion  }  } = getConfig();
    return appVersion ? appVersion.split(".").slice(0, 2).join(".") : "";
};
/**
 * Generate the base properties for any event. We added url data, experiment
 * data. And a few other things as well.
 *
 * @export
 * @returns {BaseProps}
 */ const genBaseProps = ()=>({
        app_version_id: getAppVersion(),
        page_referrer: document?.referrer ?? "",
        query_string: window?.document?.location?.search ?? "",
        page: window?.document?.location?.pathname ?? "",
        path: window?.document?.location?.pathname ?? "",
        experiments: [],
        tm_source: "",
        status: 200
    });
/**
 * Tracks a user
 *
 * @param {*} [userProps={}]
 */ const userTrack = (userProps = {})=>{
    try {
        if (isBrowser) {
            // Track user
            console.info("Stub User Tracking Event", {
                ...userProps
            });
        }
    } catch (error) {
        console.error("Event error", JSON.stringify(formatLog({
            error
        })));
    }
};
/**
 * TrackedElement: Wraps an element in an intersection observer with tracking props.
 */ const TrackedElement = (props)=>{
    const { children , eventName , enabled =true , callback , ...restProps } = props;
    const intersectionProps = {
        triggerOnce: true,
        rootMargin: "0px",
        ...restProps
    };
    const { ref , inView  } = useInView(intersectionProps);
    useEffect(()=>{
        if (inView && enabled) {
            if (callback) {
                callback();
            }
        }
    }, [
        inView
    ]);
    return /*#__PURE__*/ _jsx("div", {
        ref: ref,
        children: children
    });
};
/**
 * Find a specific type of ancestor of this element.
 */ const findParentElement = (el, elementTypes)=>{
    if (elementTypes.includes(el.tagName)) {
        return el;
    }
    if (el.parentElement && el.parentElement !== document.body) {
        return findParentElement(el.parentElement, elementTypes);
    }
    return null;
};
const getTrackingPropsAsDataAttrs = (props)=>{
    const { clickEvent , viewEvent , eventProps  } = props;
    const trackingProps = {};
    if (clickEvent) {
        trackingProps.oskarClick = clickEvent;
    }
    if (props.viewEvent) {
        trackingProps.oskarView = viewEvent;
    }
    trackingProps.oskarProps = JSON.stringify(eventProps || {});
    return trackingProps;
};
const pushDataLayerEvent = (event, props = {})=>{
    if ((0,browser/* isBrowser */.jU)() && window.dataLayer) {
        window.dataLayer.push({
            event,
            ...props
        });
    }
};
/**
 * genJobTrackingProps: Generate the props for a tracked element.
 */ const genJobTrackingProps = (job, order)=>JSON.stringify({
        company_id: job.hit.company.legacy_id,
        company_name: job.hit.company.name,
        company_short_name: job.hit.company.short_name,
        job_id: job.hit.legacy_id,
        job_level: job.hit.levels.map((level)=>level.code),
        job_locations: job.hit.locations.map((location)=>location.address),
        job_name: job.hit.title,
        job_short_name: job.hit.short_title,
        job_type: job.hit.apply_type,
        sp_impression_component: "tile",
        sp_impression_tile_type: "job",
        sp_impression_position: "main",
        sp_tile_type: "job",
        sp_tile_entity_id: job.hit.legacy_id.toString(),
        sp_tile_entity_uuid: job.hit.id,
        sp_tile_company_id: job.hit.company.legacy_id.toString(),
        sp_tile_location: "job_section",
        sp_tile_order: order + 1
    });
/**
 * The SnowPlowInit function initializes the Snowplow tracker and tracks user interactions on a web page. It uses the
 * react-intersection-observer library to detect when a component is in view, and the @themuse/snowplow-js-client
 * library to send tracking events to a Snowplow collector. The function also sets up a useEffect hook to trigger a
 * page view event when the user is initialized.
 */ const SnowPlowInit = ()=>{
    const { publicRuntimeConfig: { snowplowCollectorUrl  }  } = (0,config["default"])();
    const user = useUserState();
    const { company  } = (0,AppContext/* useAppState */.mr)();
    const { 0: pageViewTriggered , 1: setPageViewTriggered  } = (0,react.useState)(false);
    const snowPlowPayload = {
        sp_page_is_external: false,
        sp_page_section: "company_profile",
        sp_page_type: "entity",
        sp_page_entity_id: company?.legacy_id?.toString() ?? null,
        sp_page_sponsor_id: company?.legacy_id?.toString() ?? null,
        sp_page_entity_uuid: company?.id ?? null
    };
    react.useEffect(()=>{
        if (!pageViewTriggered) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(snowPlowPayload);
            (0,build.initSnowplowTracker)(snowplowCollectorUrl);
            (0,build.trackSnowplowClicks)();
        }
    }, []);
    react.useEffect(()=>{
        if (user.isInitialized && !pageViewTriggered) {
            (0,build.triggerSnowplowPageViewEvent)();
            setPageViewTriggered(true);
            (0,build.trackSnowplowImpressions)();
        }
    }, [
        user.isInitialized
    ]);
    return null;
};


// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/hooks/useSessionStorage/useSessionStorage.tsx
var useSessionStorage = __webpack_require__(5347);
// EXTERNAL MODULE: ./src/interfaces/context/appContextInterfaces.ts
var appContextInterfaces = __webpack_require__(4182);
;// CONCATENATED MODULE: ./src/mocks/mockUser.json
var mockUser_namespaceObject = JSON.parse('{"logged_in":false,"view_bookings":false,"company":{"id":134,"name":"Test Company","short_name":"test-company"},"location":{"city":"Brooklyn","region":"New York","country":"United States","dma":"New York, NY","lat":40.7099,"lon":-73.9591,"accuracy_radius":5},"cropped_name":"Test","email":"testuser@test.com","favorite_posts":[{"id":667845,"post_id":24160},{"id":667846,"post_id":24168}],"name":"Test User","id":543536}');
// EXTERNAL MODULE: ./src/utils/axiosClient.ts
var axiosClient = __webpack_require__(6704);
;// CONCATENATED MODULE: ./src/utils/location.ts


/**
 * Get data from Carmen using requesters ip address by default
 * @param ip optional IP address to lookup
 */ const getCarmenData = async (ip)=>{
    const { publicRuntimeConfig: { apiRequestTimeoutMs , carmenApiHost  }  } = (0,config["default"])();
    const suffix = ip ? `/ip/${ip}` : "/me";
    const carmenUrl = `${carmenApiHost}${suffix}`;
    const response = await axiosClient/* axiosClient.get */.U.get(carmenUrl, {
        timeout: apiRequestTimeoutMs
    });
    return response.data;
};
const locationIsRemote = (location)=>[
        "Flexible / Remote",
        "Remote / Flexible"
    ].map((a)=>a.toLowerCase()).includes(location?.value.toLowerCase());

// EXTERNAL MODULE: ./src/utils/api.ts + 1 modules
var api = __webpack_require__(6366);
;// CONCATENATED MODULE: ./src/utils/user.tsx









const setUserCarmenData = async (setUserLocation)=>{
    try {
        const carmenResponse = await getCarmenData();
        if (carmenResponse) {
            setUserLocation(JSON.stringify(carmenResponse));
        }
    } catch (error) {
        const msg = `${"company-renderer"} was unable to load location from Carmen.`;
        console.error(msg);
        console.error(error);
    }
};
const setUser = async (userLocation, dispatch)=>{
    try {
        let apiUser;
        // User only works in production and staging.
        if (![
            "www.themuse.com",
            "www.staging-themuse.com"
        ].includes(window.location.host)) {
            apiUser = mockUser_namespaceObject;
        } else {
            apiUser = await (0,api/* fetchUser */.BT)();
        }
        const userData = userLocation ? {
            location: JSON.parse(userLocation)
        } : {};
        const payload = {
            ...apiUser,
            ...userData,
            isInitialized: true
        };
        dispatch({
            type: appContextInterfaces/* UserActionTypes.updateUser */.F.updateUser,
            payload
        });
    } catch (error) {
        const msg = "Company Renderer was unable to request the user.";
        console.error(msg, JSON.stringify((0,logging/* formatLog */.U)({
            error
        })));
    }
};
const UserInit = ({ children  })=>{
    const [userLocation, setUserLocation] = (0,useSessionStorage/* default */.Z)("user_location");
    const appDispatch = useUserDispatch();
    react.useEffect(()=>{
        setUser(userLocation, appDispatch).catch(console.error);
    }, [
        userLocation
    ]);
    react.useEffect(()=>{
        setUserCarmenData(setUserLocation).catch(console.error);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};


// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/utils/browser.tsx
var utils_browser = __webpack_require__(3649);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Icons/Search.tsx
var Search = __webpack_require__(4940);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Header/Header.tsx + 28 modules
var Header = __webpack_require__(5496);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Footer/Footer.tsx + 8 modules
var Footer = __webpack_require__(2344);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(3135);
// EXTERNAL MODULE: ./src/utils/url.ts
var url = __webpack_require__(5934);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/CulturesNav.module.scss
var CulturesNav_module = __webpack_require__(757);
var CulturesNav_module_default = /*#__PURE__*/__webpack_require__.n(CulturesNav_module);
;// CONCATENATED MODULE: ./src/components/CulturesNav.tsx

/* eslint-disable camelcase, jsx-a11y/anchor-is-valid */ 






const CultureLink = ({ activeCulture , culture , location  })=>{
    const { code , name  } = culture;
    const { pathname , query  } = location;
    const linkQuery = (0,url/* setQueryParam */.s)({
        key: "culture",
        query,
        value: code
    });
    const active = !code && !activeCulture?.code || code === activeCulture?.code;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: {
            pathname,
            query: linkQuery
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            "aria-current": active,
            className: classnames_default()((CulturesNav_module_default()).link, {
                [(CulturesNav_module_default())["link--active"]]: active
            }),
            children: name
        })
    });
};
const CulturesNav = ()=>{
    const router = (0,next_router.useRouter)();
    const { cultures  } = (0,AppContext/* useAppState */.mr)();
    const location = (0,react.useMemo)(()=>(0,url/* getPathParts */.Z)(router.asPath), [
        router.asPath
    ]);
    const activeCulture = (0,react.useMemo)(()=>{
        if (!cultures) {
            return null;
        }
        const { query  } = (0,url/* getPathParts */.Z)(router.asPath);
        const locationCulture = new URLSearchParams(query).get("culture");
        return cultures.find(({ code  })=>code === locationCulture) || null;
    }, [
        cultures,
        router.asPath
    ]);
    return !!cultures?.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
        className: (CulturesNav_module_default()).nav,
        "aria-label": "Filter by Culture",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CultureLink, {
                activeCulture: activeCulture,
                culture: {
                    id: "main",
                    name: "All Content"
                },
                location: location
            }),
            cultures?.map((culture)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(CultureLink, {
                    activeCulture: activeCulture,
                    culture: culture,
                    location: location
                }, culture.id))
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Icons/BrokenImageIcon.tsx

/* eslint-disable max-len */ 
const BrokenImageIcon = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 29 37",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            stroke: "#767676",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M28.5 35.028a1 1 0 0 1-1 1h-13V1.972a1 1 0 0 1 1.582-.814l12 8.572a1 1 0 0 1 .418.814v24.484ZM26.5 8.6V3.028m-12 7h4m-4 6h6m-20 6h6m-6 6h6m8-6h9"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M18.5 36.028v-7a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v7m-10-20h-13a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h13"
                })
            ]
        })
    });
BrokenImageIcon.displayName = "BrokenImageIcon";


;// CONCATENATED MODULE: ./src/components/Icons/DiversityInclusion.tsx

/* eslint-disable max-len */ const DiversityInclusion = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        "aria-hidden": true,
        role: "img",
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "12.0752",
                cy: "11.6255",
                r: "4.24418",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.6257 4.96914H13.3237V8.86586H10.869L10.2719 9.19758L8.67967 10.6084H6.95472H4.9644L4.58907 10.0997L4.41154 9.14882C4.4033 8.90263 2.7972 9.14882 3.151 8.08731C2.97411 7.35702 4.16883 7.60743 4.16324 7.35702C4.158 7.1224 3.32752 6.96125 3.32752 6.44715C3.07926 5.87763 4.36099 5.84693 4.16324 5.54374C3.98276 5.26703 3.72084 5.19131 3.72602 4.77011C3.73233 4.25691 4.5925 4.19106 4.63267 4.1509C4.75651 4.02706 7.79506 4.0993 9.29886 4.1509C9.69693 4.42365 10.5196 4.96914 10.6257 4.96914Z",
                fill: "#AEE2F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.49496 8.95261V9.76433C4.49496 9.97962 4.58049 10.1861 4.73271 10.3383C4.88494 10.4905 5.09141 10.5761 5.30669 10.5761H8.85554L10.3767 9.3253C10.4749 9.20331 10.5983 9.10392 10.7383 9.03388C10.8784 8.96384 11.0319 8.92481 11.1884 8.91943H13.4239",
                stroke: "#1D2D5A",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.4239 4.89424H10.5829L9.3653 4.08252H4.90083C3.35855 4.08252 3.40807 5.62479 4.27499 5.62479H4.18326C3.95829 5.62479 3.74254 5.71416 3.58346 5.87324C3.42438 6.03232 3.33501 6.24807 3.33501 6.47304C3.33501 6.69801 3.42438 6.91377 3.58346 7.07285C3.74254 7.23193 3.95829 7.32129 4.18326 7.32129H3.82042C3.62367 7.32201 3.43367 7.39312 3.28478 7.52176C3.1359 7.65039 3.03797 7.82806 3.0087 8.02262C2.99172 8.1377 2.99966 8.25508 3.032 8.36682C3.06434 8.47855 3.12032 8.58203 3.19614 8.67025C3.27196 8.75846 3.36585 8.82935 3.47146 8.87811C3.57707 8.92687 3.69193 8.95236 3.80825 8.95286H6.93013",
                stroke: "#1D2D5A",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.921 10.6257L18.921 13.3237L15.0243 13.3237L15.0243 10.869L14.6926 10.2719L13.2818 8.67967L13.2818 6.95472L13.2818 4.9644L13.7904 4.58907L14.7413 4.41154C14.9875 4.4033 14.7413 2.7972 15.8028 3.151C16.5331 2.97411 16.2827 4.16883 16.5331 4.16324C16.7677 4.158 16.9289 3.32752 17.443 3.32752C18.0125 3.07926 18.0432 4.36099 18.3464 4.16324C18.6231 3.98276 18.6988 3.72084 19.12 3.72602C19.6332 3.73233 19.6991 4.5925 19.7392 4.63267C19.8631 4.75651 19.7908 7.79506 19.7392 9.29886C19.4665 9.69693 18.921 10.5196 18.921 10.6257Z",
                fill: "#AEE2F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.9373 4.49512L14.1256 4.49512C13.9103 4.49512 13.7038 4.58064 13.5516 4.73287C13.3994 4.88509 13.3138 5.09156 13.3138 5.30684L13.3138 8.85569L14.5646 10.3769C14.6866 10.4751 14.786 10.5984 14.856 10.7385C14.926 10.8786 14.9651 11.0321 14.9705 11.1886L14.9705 13.4241",
                stroke: "#1D2D5A",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.996 13.4239L18.996 10.5829L19.8077 9.3653L19.8077 4.90083C19.8077 3.35855 18.2654 3.40807 18.2654 4.27499L18.2654 4.18326C18.2654 3.95829 18.1761 3.74254 18.017 3.58346C17.8579 3.42438 17.6422 3.33501 17.4172 3.33501C17.1922 3.33501 16.9765 3.42438 16.8174 3.58346C16.6583 3.74254 16.5689 3.95829 16.5689 4.18326L16.5689 3.82042C16.5682 3.62367 16.4971 3.43367 16.3685 3.28478C16.2398 3.1359 16.0622 3.03797 15.8676 3.0087C15.7525 2.99171 15.6351 2.99966 15.5234 3.032C15.4117 3.06434 15.3082 3.12032 15.22 3.19614C15.1318 3.27196 15.0609 3.36585 15.0121 3.47146C14.9634 3.57707 14.9379 3.69193 14.9374 3.80825L14.9374 6.93013",
                stroke: "#1D2D5A",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.3743 19.0631L10.6763 19.0631L10.6763 15.1664L13.131 15.1664L13.7281 14.8346L15.3203 13.4238L17.0453 13.4238L19.0356 13.4238L19.4109 13.9325L19.5885 14.8834C19.5967 15.1296 21.2028 14.8834 20.849 15.9449C21.0259 16.6752 19.8312 16.4248 19.8368 16.6752C19.842 16.9098 20.6725 17.071 20.6725 17.5851C20.9207 18.1546 19.639 18.1853 19.8368 18.4885C20.0172 18.7652 20.2792 18.8409 20.274 19.2621C20.2677 19.7753 19.4075 19.8412 19.3673 19.8813C19.2435 20.0052 16.2049 19.9329 14.7011 19.8813C14.3031 19.6086 13.4804 19.0631 13.3743 19.0631Z",
                fill: "#AEE2F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.505 15.0791L19.505 14.2674C19.505 14.0521 19.4195 13.8457 19.2673 13.6934C19.1151 13.5412 18.9086 13.4557 18.6933 13.4557L15.1445 13.4557L13.6233 14.7064C13.5251 14.8284 13.4017 14.9278 13.2617 14.9979C13.1216 15.0679 12.9681 15.1069 12.8116 15.1123L10.5761 15.1123",
                stroke: "#1D2D5A",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.5761 19.138L13.4171 19.138L14.6347 19.9497L19.0992 19.9497C20.6414 19.9497 20.5919 18.4074 19.725 18.4074L19.8167 18.4074C20.0417 18.4074 20.2575 18.3181 20.4165 18.159C20.5756 17.9999 20.665 17.7842 20.665 17.5592C20.665 17.3342 20.5756 17.1185 20.4165 16.9594C20.2575 16.8003 20.0417 16.7109 19.8167 16.7109L20.1796 16.7109C20.3763 16.7102 20.5663 16.6391 20.7152 16.5105C20.8641 16.3818 20.962 16.2042 20.9913 16.0096C21.0083 15.8945 21.0003 15.7771 20.968 15.6654C20.9357 15.5537 20.8797 15.4502 20.8039 15.362C20.728 15.2738 20.6341 15.2029 20.5285 15.1541C20.4229 15.1054 20.3081 15.0799 20.1918 15.0794L17.0699 15.0794",
                stroke: "#1D2D5A",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.57315 13.5505L5.57315 10.8525L8.69132 10.8525L8.69132 13.1632L9.02304 13.7603L11.2124 15.3526L11.2124 17.0775L11.2124 19.0678L10.7038 19.4432L9.75282 19.6207C9.50663 19.6289 9.75282 21.235 8.69132 20.8812C7.96102 21.0581 8.21143 19.8634 7.96102 19.869C7.7264 19.8742 7.56526 20.7047 7.05115 20.7047C6.48164 20.953 6.45093 19.6712 6.14774 19.869C5.87103 20.0495 5.79532 20.3114 5.37411 20.3062C4.86092 20.2999 4.79506 19.4397 4.7549 19.3996C4.63106 19.2757 4.7033 16.2372 4.7549 14.7334C5.02765 14.3353 5.57315 13.6567 5.57315 13.5505Z",
                fill: "#AEE2F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.49382 19.5371L10.3055 19.5371C10.5208 19.5371 10.7273 19.4516 10.8795 19.2994C11.0317 19.1471 11.1173 18.9407 11.1173 18.7254L11.1173 15.1765L9.08796 13.6554C8.96597 13.5572 8.86658 13.4338 8.79655 13.2937C8.72651 13.1537 8.68747 13.0002 8.6821 12.8436L8.6821 10.6082",
                stroke: "#1D2D5A",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.43523 10.6083L5.43523 13.4493L4.6235 14.6669L4.6235 19.1314C4.6235 20.6737 6.16578 20.6242 6.16578 19.7572L6.16578 19.849C6.16578 20.0739 6.25515 20.2897 6.41423 20.4488C6.5733 20.6078 6.78906 20.6972 7.01403 20.6972C7.239 20.6972 7.45476 20.6078 7.61383 20.4488C7.77291 20.2897 7.86228 20.0739 7.86228 19.849L7.86228 20.2118C7.863 20.4086 7.93411 20.5986 8.06274 20.7474C8.19137 20.8963 8.36904 20.9943 8.56361 21.0235C8.67868 21.0405 8.79606 21.0326 8.9078 21.0002C9.01954 20.9679 9.12302 20.9119 9.21123 20.8361C9.29944 20.7603 9.37033 20.6664 9.41909 20.5608C9.46785 20.4552 9.49335 20.3403 9.49384 20.224L9.49384 17.1021",
                stroke: "#1D2D5A",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
DiversityInclusion.displayName = "DiversityInclusion";

;// CONCATENATED MODULE: ./src/components/Icons/Finance.tsx

/* eslint-disable max-len */ const Finance = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "18",
        viewBox: "0 0 20 18",
        fill: "none",
        "aria-hidden": true,
        role: "img",
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.2253 13.0164C14.922 12.5053 15.4918 11.841 15.8907 11.0747C16.2897 10.3083 16.5071 9.46052 16.5262 8.59677C16.5262 5.24564 13.2661 2.52588 9.24115 2.52588C8.44653 2.52582 7.65578 2.6365 6.89171 2.85472C6.43636 2.21465 5.79842 1.72693 5.06134 1.45538C4.98543 1.4292 4.90439 1.42147 4.82491 1.43281C4.74542 1.44416 4.66978 1.47426 4.60423 1.52063C4.53868 1.56699 4.48511 1.6283 4.44795 1.69947C4.41078 1.77064 4.39109 1.84963 4.3905 1.92992V4.0952C3.57005 4.7046 2.93696 5.53189 2.56316 6.48309H1.55135C1.41717 6.48309 1.28849 6.53639 1.19362 6.63126C1.09874 6.72614 1.04544 6.85482 1.04544 6.989V10.0244C1.04544 10.1586 1.09874 10.2873 1.19362 10.3822C1.28849 10.477 1.41717 10.5303 1.55135 10.5303H2.56316C2.96882 11.6137 3.67763 12.5575 4.60501 13.2491L3.97161 14.9692C3.91147 15.1198 3.8821 15.2809 3.88525 15.4431C3.88841 15.6052 3.92401 15.7651 3.98996 15.9132C4.05591 16.0614 4.15087 16.1948 4.26924 16.3057C4.38761 16.4166 4.52699 16.5026 4.67915 16.5587C4.83131 16.6148 4.99317 16.6398 5.15517 16.6324C5.31717 16.6249 5.47604 16.585 5.62238 16.5152C5.76873 16.4453 5.89959 16.3468 6.00725 16.2255C6.11491 16.1042 6.19718 15.9626 6.24921 15.809L6.80267 14.3075C8.52488 14.8235 10.3659 14.7835 12.0641 14.1931L12.6601 15.812C12.7121 15.9656 12.7944 16.1073 12.902 16.2285C13.0097 16.3498 13.1405 16.4483 13.2869 16.5182C13.4332 16.5881 13.5921 16.6279 13.7541 16.6354C13.9161 16.6429 14.078 16.6178 14.2301 16.5617C14.3823 16.5056 14.5217 16.4196 14.64 16.3087C14.7584 16.1979 14.8534 16.0644 14.9193 15.9163C14.9853 15.7681 15.0209 15.6082 15.024 15.4461C15.0272 15.284 14.9978 15.1228 14.9377 14.9722L14.2253 13.0164Z",
                fill: "#AEE2F7",
                stroke: "#1D2D5A",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.9268 6.72703C12.1348 5.84015 11.0394 5.28211 9.85636 5.1629",
                stroke: "#1D2D5A",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.5262 8.59687C18.1451 8.59687 18.9545 7.78742 18.9545 6.57324",
                stroke: "#1D2D5A",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                filter: "url(#filter0_d_342_533)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M5.96257 6.30371C6.16918 6.30371 6.37116 6.36498 6.54295 6.47977C6.71474 6.59456 6.84864 6.75771 6.92771 6.9486C7.00678 7.13949 7.02747 7.34953 6.98716 7.55218C6.94685 7.75482 6.84735 7.94096 6.70126 8.08706C6.55516 8.23316 6.36902 8.33265 6.16637 8.37296C5.96373 8.41327 5.75368 8.39258 5.56279 8.31351C5.37191 8.23444 5.20875 8.10055 5.09396 7.92875C4.97918 7.75696 4.91791 7.55499 4.91791 7.34837C4.91791 7.07131 5.02797 6.8056 5.22388 6.60968C5.41979 6.41377 5.68551 6.30371 5.96257 6.30371Z",
                    fill: "#1D2D5A"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                    id: "filter0_d_342_533",
                    x: "0.342015",
                    y: "6.30371",
                    width: "11.2411",
                    height: "11.2411",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                            dy: "4.57589"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                            stdDeviation: "2.28795"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_342_533"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect1_dropShadow_342_533",
                            result: "shape"
                        })
                    ]
                })
            })
        ]
    });
Finance.displayName = "Finance";

;// CONCATENATED MODULE: ./src/components/Icons/FolderIcon.tsx

/* eslint-disable max-len */ 
const FolderIcon = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 71 57",
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#0074A8",
                d: "M70.243 36.586V3.714c0-1.93-1.45-3.437-3.2-3.437h-17.35c-1.022 0-1.98.515-2.576 1.43L45.6 4.014c-.595.916-1.554 1.431-2.575 1.431H13.367c-1.75 0-3.173 1.593-3.173 3.523v36.945c0 1.93 1.423 3.522 3.173 3.522h52.356l.269 1.438c0 1.165.96 2.1 2.126 2.1a2.131 2.131 0 0 0 2.125-2.119V36.586Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#59CAFC",
                d: "M68.118 52.966c-1.166 0-2.126-.942-2.126-2.108l-2.643-14.272h.002l-2.605-12.954c-.314-1.558-1.986-2.826-3.736-2.826H3.437A2.684 2.684 0 0 0 .81 24.019l.867 4.31 5.055 25.126c.313 1.558 1.986 2.822 3.736 2.822h53.676c.067 0 .131-.002.196-.006a5.638 5.638 0 0 0 5.811-4.807 2.133 2.133 0 0 1-2.033 1.502Z"
            })
        ]
    });
FolderIcon.displayName = "FolderIcon";


;// CONCATENATED MODULE: ./src/components/Icons/HealthWellness.tsx

/* eslint-disable max-len */ const HealthWellness = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": true,
        role: "img",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M16.7208 6.7942C16.7208 6.50167 16.6046 6.22112 16.3978 6.01428C16.1909 5.80743 15.9104 5.69122 15.6179 5.69122H12.3089V2.38228C12.3089 2.08975 12.1927 1.8092 11.9859 1.60235C11.779 1.3955 11.4985 1.2793 11.2059 1.2793H6.79402C6.50149 1.2793 6.22094 1.3955 6.01409 1.60235C5.80724 1.8092 5.69104 2.08975 5.69104 2.38228V5.69122H2.38209C2.08957 5.69122 1.80902 5.80743 1.60217 6.01428C1.39532 6.22112 1.27911 6.50167 1.27911 6.7942V11.2061C1.27911 11.4987 1.39532 11.7792 1.60217 11.986C1.80902 12.1929 2.08957 12.3091 2.38209 12.3091H5.69104V15.618C5.69104 15.9106 5.80724 16.1911 6.01409 16.398C6.22094 16.6048 6.50149 16.721 6.79402 16.721H11.2059C11.4985 16.721 11.779 16.6048 11.9859 16.398C12.1927 16.1911 12.3089 15.9106 12.3089 15.618V12.3091H15.6179C15.9104 12.3091 16.1909 12.1929 16.3978 11.986C16.6046 11.7792 16.7208 11.4987 16.7208 11.2061V6.7942Z",
            fill: "#AEE2F7",
            stroke: "#1D2D5A",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
HealthWellness.displayName = "HealthWellness";

;// CONCATENATED MODULE: ./src/components/Icons/IndustryIcon.tsx

/* eslint-disable max-len */ 
const IndustryIcon = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 18 16",
        "aria-hidden": true,
        role: "img",
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                stroke: "#505050",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "10",
                d: "M14.847 3.861H2.55A2.05 2.05 0 0 0 .5 5.911v7.173a2.05 2.05 0 0 0 2.05 2.05h12.297a2.05 2.05 0 0 0 2.05-2.05V5.911a2.05 2.05 0 0 0-2.05-2.05ZM.5 7.96h7.119m2.159 0h7.12"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                stroke: "#505050",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "10",
                d: "M11.773 3.861H5.624l.37-1.783a.986.986 0 0 1 1.011-.689h3.387a.986.986 0 0 1 1.011.69l.37 1.782ZM9.266 6.935H8.131a.512.512 0 0 0-.512.512v2.05c0 .283.23.512.512.512h1.135a.512.512 0 0 0 .512-.512v-2.05a.512.512 0 0 0-.512-.512Z"
            })
        ]
    });
IndustryIcon.displayName = "IndustryIcon";

;// CONCATENATED MODULE: ./src/components/Icons/OfficeLife.tsx

/* eslint-disable max-len */ const OfficeLife = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": true,
        role: "img",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            id: "icons",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    id: "Vector",
                    d: "M13.4878 10.1357H14.5598C15.1284 10.1357 15.6737 10.4366 16.0758 10.9722C16.4778 11.5078 16.7037 12.2342 16.7037 12.9917C16.7037 13.7491 16.4778 14.4755 16.0758 15.0111C15.6737 15.5467 15.1284 15.8476 14.5598 15.8476H13.4545",
                    stroke: "#1D2D5A",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    id: "Rectangle 25",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                            id: "path-2-inside-1_344_2921",
                            fill: "white",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M1.17621 8.21522C1.17621 7.8844 1.44439 7.61621 1.77522 7.61621H13.2085C13.5393 7.61621 13.8075 7.8844 13.8075 8.21522V16.2619C13.8075 17.5852 12.7347 18.658 11.4114 18.658H3.57225C2.24895 18.658 1.17621 17.5852 1.17621 16.2619V8.21522Z"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M1.17621 8.21522C1.17621 7.8844 1.44439 7.61621 1.77522 7.61621H13.2085C13.5393 7.61621 13.8075 7.8844 13.8075 8.21522V16.2619C13.8075 17.5852 12.7347 18.658 11.4114 18.658H3.57225C2.24895 18.658 1.17621 17.5852 1.17621 16.2619V8.21522Z",
                            fill: "#AEE2F7",
                            stroke: "#1D2D5A",
                            strokeWidth: "2",
                            mask: "url(#path-2-inside-1_344_2921)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    id: "Vector_2",
                    d: "M8.91584 1.44678L9.81915 2.19993C9.90675 2.27325 9.9772 2.36488 10.0255 2.46838C10.0739 2.57188 10.0989 2.68472 10.0989 2.79895C10.0989 2.91318 10.0739 3.02602 10.0255 3.12951C9.9772 3.23301 9.90675 3.32464 9.81915 3.39796L8.91584 4.15031C8.82824 4.22363 8.75778 4.31526 8.70944 4.41876C8.6611 4.52226 8.63604 4.6351 8.63604 4.74933C8.63604 4.86356 8.6611 4.9764 8.70944 5.07989C8.75778 5.18339 8.82824 5.27502 8.91584 5.34834L9.47491 5.81557",
                    stroke: "#1D2D5A",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    id: "Vector_3",
                    d: "M5.49924 1.44678L6.40255 2.19993C6.49015 2.27325 6.5606 2.36488 6.60895 2.46838C6.65729 2.57188 6.68234 2.68472 6.68234 2.79895C6.68234 2.91318 6.65729 3.02602 6.60895 3.12951C6.5606 3.23301 6.49015 3.32464 6.40255 3.39796L5.49924 4.15031C5.41164 4.22363 5.34119 4.31526 5.29285 4.41876C5.2445 4.52226 5.21945 4.6351 5.21945 4.74933C5.21945 4.86356 5.2445 4.9764 5.29285 5.07989C5.34119 5.18339 5.41164 5.27502 5.49924 5.34834L6.05832 5.81557",
                    stroke: "#1D2D5A",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        })
    });
OfficeLife.displayName = "OfficeLife";

;// CONCATENATED MODULE: ./src/components/Icons/ParentalBenefits.tsx

/* eslint-disable max-len */ const ParentalBenefits = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        "aria-hidden": true,
        role: "img",
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_348_316)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M8.96849 3.5625C10.4062 3.56184 11.8207 3.92552 13.0797 4.61959C14.3388 5.31366 15.4015 6.31548 16.1685 7.5315C15.8894 5.82024 15.0194 4.26092 13.7097 3.12471C12.4 1.98849 10.7335 1.34725 8.99999 1.3125C7.29011 1.34552 5.64437 1.9694 4.34229 3.07816C3.04021 4.18693 2.16206 5.71223 1.85699 7.395C2.63172 6.21669 3.68728 5.24951 4.92866 4.58051C6.17006 3.9115 7.55834 3.56168 8.96849 3.5625Z",
                        fill: "#AEE2F7",
                        stroke: "#1D2D5A",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M17.625 9.5625C17.625 9.14445 17.4852 8.7384 17.228 8.40893C16.9708 8.07937 16.6108 7.84522 16.2053 7.74375C15.9686 5.98862 15.1124 4.37588 13.7912 3.19657C12.4699 2.01725 10.7706 1.34903 9.00001 1.3125C7.22937 1.34903 5.53011 2.01725 4.20887 3.19657C2.88762 4.37588 2.03142 5.98862 1.79476 7.74375C1.36627 7.8513 0.989509 8.10668 0.730932 8.46488C0.47235 8.82307 0.348554 9.26108 0.381374 9.70162C0.414194 10.1422 0.601523 10.557 0.910324 10.873C1.21913 11.1889 1.62957 11.3856 2.06926 11.4285C2.51424 12.9287 3.42639 14.2478 4.67295 15.1936C5.91951 16.1395 7.43541 16.6628 9.00001 16.6875C10.5646 16.6628 12.0805 16.1395 13.3271 15.1936C14.5736 14.2478 15.4858 12.9287 15.9308 11.4285C16.3946 11.3836 16.825 11.1676 17.1382 10.8226C17.4514 10.4776 17.6249 10.0285 17.625 9.5625Z",
                        fill: "#AEE2F7",
                        stroke: "#1D2D5A",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M9 1.3125C9.46777 1.32132 9.9162 1.50126 10.2603 1.81829C10.6044 2.13533 10.8205 2.56748 10.8675 3.033C10.9079 3.43664 10.7865 3.83983 10.5298 4.15399C10.2732 4.46815 9.90232 4.66759 9.49875 4.7085C9.33885 4.72468 9.1773 4.70917 9.0234 4.66289C8.86942 4.6166 8.72617 4.54044 8.60167 4.43875C8.47725 4.33706 8.37405 4.21183 8.298 4.07023C8.22195 3.92863 8.17455 3.77343 8.1585 3.6135C8.14657 3.50881 8.1522 3.40286 8.175 3.3",
                        fill: "#AEE2F7"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M9 1.3125C9.46777 1.32132 9.9162 1.50126 10.2603 1.81829C10.6044 2.13533 10.8205 2.56748 10.8675 3.033C10.9079 3.43664 10.7865 3.83983 10.5298 4.15399C10.2732 4.46815 9.90232 4.66759 9.49875 4.7085C9.33885 4.72468 9.1773 4.70917 9.0234 4.66289C8.86942 4.6166 8.72617 4.54044 8.60167 4.43875C8.47725 4.33706 8.37405 4.21183 8.298 4.07023C8.22195 3.92863 8.17455 3.77343 8.1585 3.6135C8.14657 3.50881 8.1522 3.40286 8.175 3.3",
                        stroke: "#1D2D5A",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M7.125 8.8125C7.125 9.27825 6.621 9.65625 6 9.65625C5.379 9.65625 4.875 9.28125 4.875 8.8125",
                        fill: "#AEE2F7"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M7.125 8.8125C7.125 9.27825 6.621 9.65625 6 9.65625C5.379 9.65625 4.875 9.28125 4.875 8.8125",
                        stroke: "#1D2D5A",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M10.875 8.8125C10.875 9.27825 11.379 9.65625 12 9.65625C12.621 9.65625 13.125 9.28125 13.125 8.8125",
                        fill: "#AEE2F7"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M10.875 8.8125C10.875 9.27825 11.379 9.65625 12 9.65625C12.621 9.65625 13.125 9.28125 13.125 8.8125",
                        stroke: "#1D2D5A",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M7.23975 12.9375C7.45032 13.1959 7.72057 13.3992 8.02725 13.5299C8.33392 13.6605 8.66775 13.7146 9 13.6875C9.33225 13.7146 9.66607 13.6605 9.97275 13.5299C10.2794 13.3992 10.5496 13.1959 10.7602 12.9375",
                        fill: "#AEE2F7"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M7.23975 12.9375C7.45032 13.1959 7.72057 13.3992 8.02725 13.5299C8.33392 13.6605 8.66775 13.7147 9 13.6875C9.33225 13.7147 9.66607 13.6605 9.97275 13.5299C10.2794 13.3992 10.5496 13.1959 10.7602 12.9375",
                        stroke: "#1D2D5A",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_348_316",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "18",
                        height: "18",
                        fill: "white"
                    })
                })
            })
        ]
    });
ParentalBenefits.displayName = "ParentalBenefits";

;// CONCATENATED MODULE: ./src/components/Icons/ProfessionalDevelopment.tsx

/* eslint-disable max-len */ const ProfessionalDevelopment = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "16",
        viewBox: "0 0 18 16",
        fill: "none",
        "aria-hidden": true,
        role: "img",
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_344_158)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M9.14271 15.3038V2.74281C9.14271 2.74281 10.9136 0.775667 16.8843 0.696318C16.9333 0.6957 16.982 0.704963 17.0273 0.723553C17.0727 0.742144 17.1139 0.769681 17.1483 0.804522C17.2187 0.875224 17.2581 0.970955 17.258 1.0707V12.8829C17.2588 12.9801 17.2215 13.0737 17.154 13.1437C17.0866 13.2137 16.9944 13.2545 16.8973 13.2573C10.9151 13.3381 9.14271 15.3038 9.14271 15.3038Z",
                        fill: "#AEE2F7",
                        stroke: "#1D2D5A",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M9.14291 15.3038V2.74281C9.14291 2.74281 7.37198 0.775667 1.4013 0.696318C1.35228 0.6957 1.30364 0.704963 1.25828 0.723553C1.21292 0.742144 1.17177 0.769681 1.13729 0.804522C1.06692 0.875224 1.02749 0.970955 1.02764 1.0707V12.8829C1.02684 12.9801 1.06416 13.0737 1.13158 13.1437C1.19901 13.2137 1.29118 13.2545 1.38832 13.2573C7.37054 13.3381 9.14291 15.3038 9.14291 15.3038Z",
                        fill: "#AEE2F7",
                        stroke: "#1D2D5A",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M11.3065 5.40849C12.5341 4.9956 13.809 4.73989 15.1009 4.64746",
                        stroke: "#1D2D5A",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M11.3065 9.43437C12.5341 9.02148 13.809 8.76577 15.1009 8.67334",
                        stroke: "#1D2D5A",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M6.97882 5.40849C5.75125 4.9956 4.47632 4.73989 3.18448 4.64746",
                        stroke: "#1D2D5A",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M6.97882 9.43437C5.75125 9.02148 4.47632 8.76577 3.18448 8.67334",
                        stroke: "#1D2D5A",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_344_158",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "18",
                        height: "16",
                        fill: "white",
                        transform: "matrix(-1 0 0 1 18 0)"
                    })
                })
            })
        ]
    });
ProfessionalDevelopment.displayName = "ProfessionalDevelopment";

;// CONCATENATED MODULE: ./src/components/Icons/SizeIcon.tsx

/* eslint-disable max-len */ 
const SizeIcon = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        "aria-hidden": true,
        role: "img",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "none",
            stroke: "#505050",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            d: "M0.998047 17C1.0112 15.8575 1.24905 14.7287 1.69805 13.678C2.18805 12.697 4.23705 12.017 6.80905 11.065C7.50905 10.807 7.39005 8.991 7.08205 8.652C6.59138 8.12067 6.21868 7.49154 5.98842 6.80595C5.75816 6.12035 5.67556 5.39379 5.74605 4.674C5.70198 4.21588 5.75268 3.75359 5.89497 3.3159C6.03726 2.87822 6.26812 2.4745 6.57316 2.12987C6.8782 1.78525 7.2509 1.50709 7.66808 1.31271C8.08525 1.11833 8.53796 1.01188 8.99805 1C9.45847 1.01134 9.91163 1.11739 10.3293 1.31153C10.7469 1.50568 11.1201 1.78376 11.4256 2.12844C11.731 2.47313 11.9622 2.87703 12.1048 3.31498C12.2473 3.75294 12.2981 4.21555 12.254 4.674C12.3245 5.39379 12.2419 6.12035 12.0117 6.80595C11.7814 7.49154 11.4087 8.12067 10.918 8.652C10.61 8.991 10.496 10.807 11.191 11.065C13.763 12.017 15.812 12.697 16.302 13.678C16.751 14.7287 16.9889 15.8575 17.002 17H0.998047Z"
        })
    });
SizeIcon.displayName = "SizeIcon";

;// CONCATENATED MODULE: ./src/components/Icons/VacationTimeoff.tsx

/* eslint-disable max-len */ const VacationTimeoff = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "21",
        height: "18",
        viewBox: "0 0 21 18",
        fill: "none",
        "aria-hidden": true,
        role: "img",
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                id: "icon",
                clipPath: "url(#clip0_344_1413)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Vector",
                        d: "M17.619 7.09114C17.756 7.04326 17.8795 6.96326 17.9791 6.85784C18.0788 6.75243 18.1518 6.62466 18.1919 6.48524C18.2321 6.34582 18.2382 6.19881 18.2099 6.05652C18.1815 5.91424 18.1195 5.78082 18.029 5.66744C16.8563 4.20238 15.2584 3.13679 13.4552 2.61735C11.652 2.09791 9.73211 2.15015 7.9598 2.76689C6.1875 3.38363 4.64992 4.53454 3.55871 6.0612C2.46751 7.58786 1.87632 9.41521 1.86652 11.2917C1.86591 11.4369 1.9001 11.5801 1.96623 11.7093C2.03236 11.8385 2.1285 11.9499 2.2466 12.0343C2.36469 12.1187 2.50129 12.1736 2.64495 12.1943C2.78861 12.215 2.93514 12.201 3.07226 12.1534L17.619 7.09114Z",
                        fill: "#AEE2F7",
                        stroke: "#1D2D5A",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Vector_2",
                        d: "M7.40748 1.12987L7.84297 2.34412",
                        stroke: "#1D2D5A",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Vector_3",
                        d: "M11.894 14.1951L10.909 11.3648L10.4165 9.94971",
                        stroke: "#1D2D5A",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Vector_4",
                        d: "M0.967407 17.2322C1.62291 17.3133 2.28825 17.247 2.91485 17.0381C3.54146 16.8293 4.11351 16.4831 4.58923 16.0249C4.93236 16.405 5.35142 16.7088 5.81932 16.9167C6.28723 17.1247 6.79356 17.2321 7.3056 17.2321C7.81763 17.2321 8.32396 17.1247 8.79187 16.9167C9.25977 16.7088 9.67884 16.405 10.022 16.0249C10.3651 16.405 10.7841 16.7088 11.2521 16.9167C11.72 17.1247 12.2263 17.2321 12.7383 17.2321C13.2504 17.2321 13.7567 17.1247 14.2246 16.9167C14.6925 16.7088 15.1116 16.405 15.4547 16.0249C15.9304 16.4831 16.5025 16.8293 17.1291 17.0381C17.7557 17.247 18.421 17.3133 19.0765 17.2322",
                        stroke: "#1D2D5A",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_344_1413",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "20",
                        height: "18",
                        fill: "white",
                        transform: "translate(0.142853)"
                    })
                })
            })
        ]
    });
VacationTimeoff.displayName = "VacationTimeoff";

;// CONCATENATED MODULE: ./src/components/Icons/WorkFlexibility.tsx

/* eslint-disable max-len */ const WorkFlexibility = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": true,
        role: "img",
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.7497 13.6875V6.375C18.7497 6.07663 18.6311 5.79048 18.4202 5.5795C18.2092 5.36853 17.923 5.25 17.6247 5.25H6.37466C6.0763 5.25 5.79015 5.36853 5.57917 5.5795C5.36819 5.79048 5.24966 6.07663 5.24966 6.375V13.6875H18.7497Z",
                fill: "#AEE2F7",
                stroke: "#666666",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.341 17.1683C20.4171 17.3395 20.4491 17.5271 20.4343 17.714C20.4195 17.9008 20.3582 18.081 20.2561 18.2382C20.1539 18.3953 20.0141 18.5244 19.8494 18.6138C19.6846 18.7032 19.5001 18.75 19.3127 18.75H4.6877C4.50027 18.75 4.3158 18.7032 4.15105 18.6138C3.9863 18.5244 3.8465 18.3953 3.74434 18.2382C3.64219 18.081 3.58091 17.9008 3.56609 17.714C3.55126 17.5271 3.58336 17.3395 3.65945 17.1683L5.2502 13.6875H18.7502L20.341 17.1683Z",
                fill: "#AEE2F7",
                stroke: "#666666",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.8752 16.5H13.1252",
                stroke: "#666666",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.95202 10.5356C8.86613 10.5356 10.4178 8.98393 10.4178 7.06981C10.4178 5.1557 8.86613 3.604 6.95202 3.604C5.0379 3.604 3.48621 5.1557 3.48621 7.06981C3.48621 8.98393 5.0379 10.5356 6.95202 10.5356Z",
                fill: "#AEE2F7",
                stroke: "#1D2D5A",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.76187 5.2041V6.59043L7.59367 7.42222",
                fill: "#AEE2F7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.76187 5.2041V6.59043L7.59367 7.42222",
                stroke: "#1D2D5A",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
WorkFlexibility.displayName = "WorkFlexibility";

;// CONCATENATED MODULE: ./src/components/Icons/index.tsx














// EXTERNAL MODULE: ./src/components/Hero.module.scss
var Hero_module = __webpack_require__(3803);
var Hero_module_default = /*#__PURE__*/__webpack_require__.n(Hero_module);
;// CONCATENATED MODULE: ./src/components/Hero.tsx

/* eslint-disable camelcase */ 




const getPilboxUrl = (imageUrl, imageWidth, imageHeight, fill)=>{
    const pilboxUrl = "https://pilbox.themuse.com/";
    const imageUrlRegex = /^https?:\/\//;
    const mode = fill ? "mode=fill&background=ccc" : "mode=crop";
    const suffix = `filter=antialias&opt=1&${mode}&pos=top&prog=1&q=keep`;
    const height = imageHeight ? `&h=${imageHeight}` : "";
    const width = imageWidth ? `&w=${imageWidth}` : "";
    if (imageUrlRegex.test(imageUrl)) {
        return `${pilboxUrl}?url=${imageUrl}${height}${width}&${suffix}`;
    }
    return "";
};
// We add the priority this way because typescript is not yet up to speed, without modifying the build in props.
const extraProps = {
    fetchpriority: "high"
};
const CompanyHeroImage = (props)=>{
    // eslint-disable-next-line max-len
    const backup = "https://assets.themuse.com/images/missing-company-hero.jpg";
    const { url =backup  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
        className: (Hero_module_default()).picture,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                media: "(min-width: 1040px)",
                srcSet: getPilboxUrl(url, 1040, 375)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                media: "(min-width: 992px)",
                srcSet: getPilboxUrl(url, 992, 375)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                media: "(min-width: 768px)",
                srcSet: getPilboxUrl(url, 768, 244)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                media: "(max-width: 375px)",
                srcSet: getPilboxUrl(url, 375, 244)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: getPilboxUrl(url || backup, 375, 244),
                alt: "",
                className: (Hero_module_default()).heroImage,
                width: "375",
                height: "244",
                ...extraProps
            })
        ]
    });
};
const CompanyLogo = (props)=>{
    const { url  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        src: url,
        alt: "",
        className: (Hero_module_default()).logo,
        "aria-hidden": "true",
        width: "128",
        height: "128",
        ...extraProps
    });
};
const Hero = ()=>{
    const { company  } = (0,AppContext/* useAppState */.mr)();
    const { snapshot_photo , logo , name  } = company;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Hero_module_default()).hero,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Hero_module_default()).heroGrid,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Hero_module_default()).heroImageWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyHeroImage, {
                        url: snapshot_photo
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Hero_module_default()).heroContentWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Hero_module_default()).logoWrapper,
                            children: logo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyLogo, {
                                url: logo
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(BrokenImageIcon, {
                                className: (Hero_module_default()).missingLogo
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: (Hero_module_default()).title,
                            children: name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CulturesNav, {})
                    ]
                })
            ]
        })
    });
};
Hero.displayName = "Hero";


// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Icons/ArrowRightShape.tsx
var ArrowRightShape = __webpack_require__(7621);
// EXTERNAL MODULE: ./src/components/ContentWell.module.scss
var ContentWell_module = __webpack_require__(7869);
var ContentWell_module_default = /*#__PURE__*/__webpack_require__.n(ContentWell_module);
// EXTERNAL MODULE: ./src/components/ArticleCardList.tsx + 1 modules
var ArticleCardList = __webpack_require__(9247);
// EXTERNAL MODULE: ./src/hooks/useEmployeeModal.tsx
var useEmployeeModal = __webpack_require__(9696);
// EXTERNAL MODULE: ./src/components/EmployeeCard/index.ts + 4 modules
var EmployeeCard = __webpack_require__(3346);
// EXTERNAL MODULE: ./src/components/EmployeeStoryModal.tsx
var EmployeeStoryModal = __webpack_require__(3543);
// EXTERNAL MODULE: ./src/components/EmployeeCardList.module.scss
var EmployeeCardList_module = __webpack_require__(2579);
var EmployeeCardList_module_default = /*#__PURE__*/__webpack_require__.n(EmployeeCardList_module);
;// CONCATENATED MODULE: ./src/components/EmployeeCardList.tsx








const EmployeeCardList = ({ className , title , viewMore , ...props })=>{
    const { employeeStories  } = (0,AppContext/* useAppState */.mr)();
    const storiesList = (0,react.useMemo)(()=>employeeStories.slice(0, 3), [
        employeeStories
    ]);
    const employeeModal = (0,useEmployeeModal/* useEmployeeModal */.$)({
        employeeStories: storiesList
    });
    return storiesList.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: classnames_default()((EmployeeCardList_module_default()).wrapper, className),
                ...props,
                children: [
                    !!title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (EmployeeCardList_module_default()).heading,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (EmployeeCardList_module_default()).cardList,
                        children: storiesList.map((employee)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(EmployeeCard/* EmployeeCard */.J, {
                                employee: employee,
                                onClick: ()=>employeeModal.setOpenStory(employee.id)
                            }, employee.id))
                    }),
                    viewMore
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmployeeStoryModal/* EmployeeStoryModal */.x, {
                employee: employeeModal.openStory,
                isOpen: employeeModal.isOpen,
                setIsOpen: employeeModal.setIsOpen
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
        readOnly: true,
        value: JSON.stringify(storiesList || "")
    });
};

// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Buttons/SquareButton.tsx + 1 modules
var SquareButton = __webpack_require__(1410);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Cards/JobCard.tsx + 1 modules
var JobCard = __webpack_require__(9177);
// EXTERNAL MODULE: ./src/utils/strings.ts
var strings = __webpack_require__(2918);
// EXTERNAL MODULE: ./src/components/JobCardListItem.module.scss
var JobCardListItem_module = __webpack_require__(4631);
var JobCardListItem_module_default = /*#__PURE__*/__webpack_require__.n(JobCardListItem_module);
;// CONCATENATED MODULE: ./src/components/JobCardListItem.tsx

/* eslint-disable camelcase */ 





/**
 * Generate the apply now URL for a job tile based on the job search data.
 */ const getJobTileApplyUrl = (job)=>{
    const { apply_type , company: urlCompany , legacy_id , short_title  } = job;
    const { short_name  } = urlCompany;
    return apply_type === "external" ? `/job/redirect/${legacy_id}` : `/jobs/${short_name}/${short_title}#apply-inline-form`;
};
/**
 * Determine the location to display for a job tile based on the user's location and the job's location information.
 */ const getJobTileLocation = (props)=>{
    const { locationType , locations , sessionDma  } = props;
    const isRemote = locationType === "virtual";
    const userLocation = sessionDma;
    // We Only care about the actual location address.
    const locationStrings = locations.map((location)=>location.address);
    // This is the fully matched location (city and state).
    const matchedLocation = locationStrings.filter((loc)=>loc === userLocation)[0];
    // We may need to match only on the last segment of the location.
    const getState = (txt)=>{
        if (typeof txt === "string") {
            return txt.split(",")[1]?.trim()?.toLowerCase();
        }
        return null;
    };
    // First location matched by region.
    const matchedRegion = locationStrings.filter((address)=>getState(address) === getState(userLocation))[0];
    // First location in the list (fall back)
    const firstLocation = locationStrings[0];
    // The location to display
    const displayLocation = matchedLocation || matchedRegion || firstLocation || "";
    // If we have more than 2 locations pluralize the string.
    const locationWord = ` location${locationStrings.length > 2 ? "s" : ""}`;
    // If we have more than 1 location we add a plus sign and the number plus the word location(s)
    const extraLocations = locationStrings.length > 1 ? ` + ${locationStrings.length - 1}${locationWord}` : "";
    // If we are remote and there is a location we will separate them with a slash.
    const separator = displayLocation ? " / " : "";
    // Build the remote string.
    const remoteString = isRemote ? `${separator}Remote` : "";
    // all together now...
    return [
        `${displayLocation}${remoteString}${extraLocations}`
    ];
};
/**
 * Generate a click event handler for a JobCardListItem component that opens a new window with a new URL
 * and triggers a Snowplow click event if the clicked element is not an anchor element.
 */ const generateHandleCardClick = (props)=>(event)=>{
        const { viewJobHref , tracking  } = props;
        // Only fire on clicking non anchor elements
        if (!(event.target instanceof HTMLAnchorElement)) {
            window.open(viewJobHref, "_blank");
            (0,build.triggerSnowplowClickEvent)(tracking);
        }
    };
/**
 * Generate a function that triggers a Snowplow click evens when a link is clicked.
 */ const generateHandleLinkClick = (props)=>()=>{
        const { tracking  } = props;
        (0,build.triggerSnowplowClickEvent)(tracking);
    };
/**
 * A React component that renders a JobCard with specific props and tracking events.
 */ const JobCardListItem = (props)=>{
    const { job , userLocationDma , order  } = props;
    const { hit  } = job;
    const { company: searchResultsCompany , id , snowplow_id , legacy_id , locations , posted_at , remote_work_location_type , short_title , title ,  } = hit;
    const applyNowHref = getJobTileApplyUrl(hit);
    const companyHref = `/profiles/${searchResultsCompany.short_name}`;
    const viewJobHref = `/jobs/${searchResultsCompany.short_name}/${short_title}`;
    const { 0: postedDate , 1: setPostedDate  } = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        setPostedDate((0,strings/* formatCardDate */.aO)(new Date(posted_at * 1000)));
    }, [
        posted_at
    ]);
    const tileLocation = getJobTileLocation({
        locationType: remote_work_location_type,
        locations,
        sessionDma: userLocationDma || ""
    });
    const snowplowTileContentProps = {
        sp_tile_type: "job",
        sp_tile_company_id: searchResultsCompany.legacy_id.toString(),
        sp_tile_entity_id: legacy_id.toString(),
        sp_tile_entity_uuid: snowplow_id || id,
        sp_tile_location: "job_section",
        sp_tile_order: order + 1
    };
    const snowplowClickBaseProps = {
        sp_click_component: "tile",
        sp_click_component_tile_type: "job",
        sp_click_position: "main",
        sp_click_target_page_section: "job_detail",
        sp_click_search_id: "" // TODO: should be searchId, but I cannot find it.
    };
    const handleCardClick = generateHandleCardClick({
        viewJobHref,
        tracking: {
            ...snowplowTileContentProps,
            ...snowplowClickBaseProps,
            sp_click_target_page_section: "job_detail"
        }
    });
    const handleCompanyNameClick = generateHandleLinkClick({
        viewJobHref,
        tracking: {
            ...snowplowTileContentProps,
            ...snowplowClickBaseProps,
            sp_click_component: "button",
            sp_click_button_type: "profile",
            sp_click_target_page_section: "profile"
        }
    });
    const handleViewJobClick = generateHandleLinkClick({
        viewJobHref,
        tracking: {
            ...snowplowTileContentProps,
            ...snowplowClickBaseProps,
            sp_click_component: "button",
            sp_click_button_type: "job_view",
            sp_click_button_text: "VIEW JOB",
            sp_click_target_page_section: "profile"
        }
    });
    // Apply on company site
    const handleApplyNowClick = generateHandleLinkClick({
        viewJobHref,
        tracking: {
            ...snowplowTileContentProps,
            ...snowplowClickBaseProps,
            sp_click_component: "button",
            sp_click_button_type: "apply",
            sp_click_button_text: "APPLY ON COMPANY SITE",
            sp_click_target_page_section: "off_site"
        }
    });
    const jobCardProps = {
        showLogo: true,
        companyName: searchResultsCompany.name,
        companyLogo: searchResultsCompany.logo,
        jobName: title,
        locations: tileLocation,
        companyHref,
        applyNowHref,
        postedDate,
        viewJobHref,
        onApplyNowClick: handleApplyNowClick,
        onViewJobClick: handleViewJobClick,
        onCompanyNameClick: handleCompanyNameClick,
        onCardClick: handleCardClick,
        heading: "h3",
        companyIsLink: false
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: (JobCardListItem_module_default()).jobCardListItem,
        "data-tracking-event-type": "impression",
        "data-tracking-props": genJobTrackingProps(job, order),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(JobCard/* default */.Z, {
            ...jobCardProps
        })
    }, job?.hit?.id);
};
JobCardListItem.displayName = "JobCardListItem";


// EXTERNAL MODULE: ./src/components/JobCardList.module.scss
var JobCardList_module = __webpack_require__(6936);
var JobCardList_module_default = /*#__PURE__*/__webpack_require__.n(JobCardList_module);
;// CONCATENATED MODULE: ./src/components/JobCardList.tsx

/* eslint-disable camelcase */ 







/**
 * The Tiles function takes in an array of job objects and a user object as props.
 * It renders a list of JobTile components.
 */ const Tiles = (props)=>{
    const { jobs , user  } = props;
    const wrapper = (0,react.useRef)();
    (0,react.useEffect)(()=>{
        (0,build.trackSnowplowImpressions)(wrapper.current || undefined);
    }, [
        jobs?.length
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: (JobCardList_module_default()).jobCardList,
        ref: wrapper,
        children: jobs.map((job, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(JobCardListItem, {
                job: job,
                userLocationDma: user?.dma,
                order: index
            }, job?.hit?.id))
    });
};
/**
 * The Empty function renders a message indicating that a company currently has no jobs.
 */ const Empty = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (JobCardList_module_default()).empty,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FolderIcon, {
                className: (JobCardList_module_default()).folder
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (JobCardList_module_default()).subtext,
                children: "This company currently has no jobs"
            })
        ]
    });
/**
 * The JobList function is a React component that fetches job data from an API and displays it in a list.
 * It also handles loading state and displays a button with a link to view more | all jobs.
 */ const JobCardList = ()=>{
    const { company , user  } = (0,AppContext/* useAppState */.mr)();
    const { short_name  } = company;
    const { 0: jobs , 1: setJobs  } = (0,react.useState)([]);
    const { 0: isLoading , 1: setLoading  } = (0,react.useState)(true);
    const fetchData = (0,react.useCallback)(async ()=>{
        const data = await (0,api/* fetchJobs */.bG)({
            company_short_name: short_name
        });
        setJobs(data?.hits ?? []);
        setLoading(false);
    }, [
        short_name
    ]);
    (0,react.useEffect)(()=>{
        fetchData();
    }, []);
    const ctaText = jobs.length ? "VIEW ALL JOBS" : "VIEW JOBS FROM OTHER COMPANIES";
    const ctaUrl = jobs.length ? `/hiring/company/${company.short_name}` : "/hiring";
    const CTATracking = {
        sp_click_component: "button",
        sp_click_button_type: "job_search",
        sp_click_button_text: ctaText,
        sp_click_position: "job_section",
        sp_click_target_page_section: "search",
        sp_tile_type: null,
        sp_tile_entity_id: null,
        sp_search_id: null
    };
    if (isLoading) return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        children: "Loading..."
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            jobs.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Tiles, {
                jobs,
                user
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Empty, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SquareButton/* default */.Z, {
                color: "secondary-100",
                className: (JobCardList_module_default()).searchButton,
                href: ctaUrl,
                onClick: ()=>(0,build.triggerSnowplowClickEvent)(CTATracking),
                type: "button",
                children: ctaText
            })
        ]
    });
};
JobCardList.displayName = "JobCardList";


;// CONCATENATED MODULE: ./src/components/ContentWell.tsx

/* eslint-disable
camelcase,
jsx-a11y/anchor-is-valid,
jsx-a11y/click-events-have-key-events,
jsx-a11y/no-static-element-interactions */ 











const VIEW_MORE_LINK_TEXT = "VIEW MORE ARTICLES";
const Description = ()=>{
    const { company  } = (0,AppContext/* useAppState */.mr)();
    if (company?.description?.length < 20) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (ContentWell_module_default()).headings,
                children: "Who We Are"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ContentWell_module_default()).contentBody,
                children: company?.description
            })
        ]
    });
};
Description.displayName = "Description";
const ContentWell = ()=>{
    const router = (0,next_router.useRouter)();
    const { FEATURE_FLAG_EMPLOYEE_STORIES  } = (0,FeatureFlagsContext/* useFeatureFlagsState */.n)();
    const getTabLink = (0,react.useCallback)((slug)=>{
        const { pathname , query  } = (0,url/* getPathParts */.Z)(router.asPath);
        const linkQuery = (0,url/* setQueryParam */.s)({
            key: "tab",
            query,
            value: slug
        });
        return {
            pathname,
            query: linkQuery
        };
    }, [
        router.asPath
    ]);
    const handleViewArticlesClick = ()=>{
        (0,build.triggerSnowplowClickEvent)({
            sp_click_button_text: null,
            sp_click_button_type: null,
            sp_click_component: "link",
            sp_click_component_tile_type: "article",
            sp_click_insert_type: null,
            sp_click_link_text: VIEW_MORE_LINK_TEXT,
            sp_click_position: "articles",
            sp_click_target_page_section: "profile",
            sp_tile_entity_id: "",
            sp_tile_type: "article"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ContentWell_module_default()).contentWell,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (ContentWell_module_default()).headings,
                children: "Hiring Now"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(JobCardList, {}),
            FEATURE_FLAG_EMPLOYEE_STORIES && /*#__PURE__*/ (0,jsx_runtime.jsx)(EmployeeCardList, {
                className: (ContentWell_module_default()).contentCardList,
                title: "Hear from the team",
                viewMore: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (ContentWell_module_default()).viewMore,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: getTabLink("team"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            className: (ContentWell_module_default()).viewMoreLink,
                            children: [
                                "VIEW MORE EMPLOYEES",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightShape/* default */.Z, {})
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCardList/* ArticleCardList */.q, {
                className: (ContentWell_module_default()).contentCardList,
                size: 3,
                title: "Articles",
                trackingLocation: "main",
                viewMore: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (ContentWell_module_default()).viewMore,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: getTabLink("articles"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            className: (ContentWell_module_default()).viewMoreLink,
                            onClick: handleViewArticlesClick,
                            children: [
                                VIEW_MORE_LINK_TEXT,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightShape/* default */.Z, {})
                            ]
                        })
                    })
                })
            })
        ]
    });
};
ContentWell.displayName = "ContentWell";


// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Tooltip/Tooltip.tsx
var Tooltip = __webpack_require__(4636);
;// CONCATENATED MODULE: ./src/components/Industries.tsx




/**
 * Renders the companies industries the associated icon.
 * Additionally renders a tooltip when more than two exist.
 *
 * If there are none does not render.
 */ const Industries = (props)=>{
    const { industries  } = props;
    if (!industries.length) return null;
    const [firstIndustryItem, secondIndustryItem, ...restIndustryList] = industries;
    const firstIndustries = [
        firstIndustryItem,
        secondIndustryItem
    ].filter(Boolean).join(", ");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IndustryIcon, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                children: [
                    firstIndustries,
                    " ",
                    restIndustryList.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                        title: "Industries",
                        triggerText: `+ ${restIndustryList.length} more`,
                        content: restIndustryList
                    }) : null
                ]
            })
        ]
    });
};
Industries.displayName = "Industries";


;// CONCATENATED MODULE: ./src/components/EmployeeRange.tsx

/* eslint-disable camelcase */ 

const formatNumberComma = (value)=>{
    const numberVal = parseInt(value, 10);
    return Number.isNaN(numberVal) ? value : new Intl.NumberFormat("en-US").format(numberVal);
};
const formatCompanySize = (size)=>{
    const sizes = size?.split("_").map((companySize)=>formatNumberComma(companySize));
    return sizes?.[1] === "plus" ? `${sizes[0]}+` : sizes?.join(" - ");
};
/**
 * Renders the employee range with its associated icon.
 */ const EmployeeRange = (props)=>{
    const { employee_range =""  } = props;
    const employees = formatCompanySize(employee_range);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SizeIcon, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                children: [
                    employees,
                    " employees"
                ]
            })
        ]
    });
};
EmployeeRange.displayName = "EmployeeRange";


// EXTERNAL MODULE: ./src/components/CompanyDetails.module.scss
var CompanyDetails_module = __webpack_require__(2958);
var CompanyDetails_module_default = /*#__PURE__*/__webpack_require__.n(CompanyDetails_module);
;// CONCATENATED MODULE: ./src/components/CompanyDetails.tsx

/* eslint-disable camelcase */ 



/**
 * Renders a list of icons and details about the company.
 */ const CompanyDetails = (props)=>{
    const { employee_range , industries  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
        className: (CompanyDetails_module_default()).companyDetails,
        "aria-label": "Company Details",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Industries, {
                industries
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmployeeRange, {
                employee_range
            })
        ]
    });
};
CompanyDetails.displayName = "CompanyDetails";


// EXTERNAL MODULE: ./src/components/Perks.module.scss
var Perks_module = __webpack_require__(9210);
var Perks_module_default = /*#__PURE__*/__webpack_require__.n(Perks_module);
;// CONCATENATED MODULE: ./src/components/Perks.tsx




/**
 * Returns the corresponding SVG icon based on the value of the `icon` parameter.
 */ const chooseIcon = (icon)=>{
    switch(icon){
        case "diversity_and_inclusion":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DiversityInclusion, {});
        case "finance":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Finance, {});
        case "health_and_wellness":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(HealthWellness, {});
        case "office_life":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(OfficeLife, {});
        case "parental_benefits":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ParentalBenefits, {});
        case "professional_development":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfessionalDevelopment, {});
        case "vacation_and_timeoff":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(VacationTimeoff, {});
        case "work_flexibility":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(WorkFlexibility, {});
        default:
            return null;
    }
};
/**
 * Renders a list of perks from the string array.
 */ const PerkList = (props)=>{
    const { list  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        children: list.filter(Boolean).map((x)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: x
            }, x))
    });
};
/**
 * Render the Perks module.
 * * Includes a title
 * * Includes a sub title for each bucket
 * * includes a list of the perks in each bucket.
 */ const Perks = (props)=>{
    const { perksAndBenefits ={}  } = props;
    const categories = Object.keys(perksAndBenefits);
    if (!categories.length) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Perks_module_default()).perks,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: "Perks and Benefits"
            }),
            categories.map((x)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Perks_module_default()).perk,
                    children: [
                        chooseIcon(perksAndBenefits[x].value),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    children: perksAndBenefits[x].name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PerkList, {
                                    list: perksAndBenefits[x].perks
                                })
                            ]
                        })
                    ]
                }, perksAndBenefits[x].value))
        ]
    });
};
Perks.displayName = "Perks";


// EXTERNAL MODULE: ./src/components/Sidebar.module.scss
var Sidebar_module = __webpack_require__(2703);
var Sidebar_module_default = /*#__PURE__*/__webpack_require__.n(Sidebar_module);
;// CONCATENATED MODULE: ./src/components/Sidebar.tsx

/* eslint-disable camelcase */ 




const Sidebar = ()=>{
    const { company  } = (0,AppContext/* useAppState */.mr)();
    const { short_description , perks_and_benefits , employee_range , industries ,  } = company;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Sidebar_module_default()).sidebar,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (Sidebar_module_default()).description,
                        children: short_description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyDetails, {
                        employee_range,
                        industries
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Perks, {
                perksAndBenefits: perks_and_benefits
            })
        ]
    });
};
Sidebar.displayName = "Sidebar";


// EXTERNAL MODULE: ./src/components/TabMain.module.scss
var TabMain_module = __webpack_require__(7286);
var TabMain_module_default = /*#__PURE__*/__webpack_require__.n(TabMain_module);
;// CONCATENATED MODULE: ./src/components/TabMain.tsx






const TabMain = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "aria-labelledby": constants/* contentTabIds.main.tab */.dn.main.tab,
        className: (TabMain_module_default()).tabMain,
        id: constants/* contentTabIds.main.panel */.dn.main.panel,
        role: "tabpanel",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Sidebar, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWell, {})
        ]
    });

;// CONCATENATED MODULE: ./src/components/CompanyPage.tsx












const CompanyNav = dynamic_default()(()=>__webpack_require__.e(/* import() */ 967).then(__webpack_require__.bind(__webpack_require__, 2967)).then((x)=>x.CompanyNav), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(2967)
            ]
    },
    ssr: false
});
const TabArticles = dynamic_default()(()=>__webpack_require__.e(/* import() */ 426).then(__webpack_require__.bind(__webpack_require__, 9426)).then((x)=>x.TabArticles), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(9426)
            ]
    },
    ssr: false
});
const TabTeam = dynamic_default()(()=>__webpack_require__.e(/* import() */ 562).then(__webpack_require__.bind(__webpack_require__, 9562)).then((x)=>x.TabTeam), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(9562)
            ]
    },
    ssr: false
});
const updateInput = async (changes, setItems, setInputValue, fetchData)=>{
    const { inputValue  } = changes;
    const jobSearchItem = {
        label: `${inputValue}`,
        value: `/search/keyword/${inputValue}/`
    };
    setInputValue(inputValue);
    if (inputValue) {
        setItems([
            jobSearchItem
        ]);
        const companyResults = await fetchData(inputValue);
        const companyList = companyResults?.length ? formatCompanySuggestions(companyResults) : [];
        setItems([
            jobSearchItem
        ].concat(companyList));
    } else {
        setItems([]);
    }
};
const formatCompanySuggestions = (companySuggestions)=>companySuggestions.slice(0, 4).map((companyResult)=>{
        const { text , value  } = companyResult;
        const { short_name  } = value; // eslint-disable-line camelcase
        return {
            label: `${text}`,
            value: `/profiles/${short_name}` // eslint-disable-line camelcase
        };
    });
const CompanyPage = (props)=>{
    const { pageId ="main-content" , headerClassName , footerClassName ,  } = props;
    const { user  } = (0,AppContext/* useAppState */.mr)();
    const router = (0,next_router.useRouter)();
    const { 0: dropdownItems , 1: setDropdownItems  } = (0,react.useState)([]);
    const { 0: inputValue , 1: setInputValue  } = (0,react.useState)("");
    const { 0: tabKey , 1: setTabKey  } = (0,react.useState)("main");
    const searchQuerySubmittedEvent = (selectedItemText)=>{
        const searchTerm = selectedItemText || inputValue;
        const eventProps = {
            search_term: searchTerm || ""
        };
        pushDataLayerEvent("searchQuerySubmitted", eventProps);
    };
    const onKeyboardSelectItem = (_, selectedItem)=>{
        if (!(0,utils_browser/* isBrowser */.j)()) return "";
        const searchPath = inputValue ? `/search/keyword/${inputValue}` : "/search";
        const selectPath = selectedItem?.value ? selectedItem?.value : searchPath;
        searchQuerySubmittedEvent(selectedItem?.label);
        return window.open(selectPath, "_blank").focus();
    };
    const onMouseSelectItem = (_, selectedItem)=>{
        searchQuerySubmittedEvent(selectedItem.label);
    };
    const dropdownProps = {
        IconComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {}),
        debounceWait: 10,
        dropdownList: dropdownItems,
        inputId: "search-input",
        onInputChange: (changes)=>updateInput(changes, setDropdownItems, setInputValue, api/* fetchCompanySuggestions */.SC),
        noResultsMessage: " ",
        onKeyboardSelectItem,
        onMouseSelectItem
    };
    const headerWithUserProps = {
        ...props,
        user
    };
    (0,react.useEffect)(()=>{
        const { query  } = (0,url/* getPathParts */.Z)(router.asPath);
        const locationTab = new URLSearchParams(query).get("tab");
        const nextTabKey = constants/* contentTabIds */.dn[locationTab] ? locationTab : "main";
        setTabKey(nextTabKey);
    }, [
        router.asPath
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                mainContainerId: pageId,
                className: headerClassName,
                enableCompanySearch: true,
                companySearchDropdownProps: dropdownProps,
                activePath: "/companies",
                showSubMenus: true,
                ...headerWithUserProps
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyNav, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                id: pageId,
                className: "pageContent",
                children: [
                    tabKey === "main" && /*#__PURE__*/ (0,jsx_runtime.jsx)(TabMain, {}),
                    tabKey === "articles" && /*#__PURE__*/ (0,jsx_runtime.jsx)(TabArticles, {}),
                    tabKey === "team" && /*#__PURE__*/ (0,jsx_runtime.jsx)(TabTeam, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {
                className: footerClassName
            })
        ]
    });
};
CompanyPage.displayName = "CompanyPage";


// EXTERNAL MODULE: ./src/styles/Home.module.scss
var Home_module = __webpack_require__(4865);
var Home_module_default = /*#__PURE__*/__webpack_require__.n(Home_module);
;// CONCATENATED MODULE: ./src/pages/index.tsx











const Home = (props)=>{
    const { initialAppParams , featureFlags  } = props;
    const { company  } = initialAppParams;
    const { publicRuntimeConfig: { museWebHost  }  } = (0,config["default"])();
    const pageLayoutProps = {
        activePath: "/companies",
        headerClassName: (Home_module_default()).pageHeader,
        pageName: (Home_module_default()).pageWrapper,
        mainClassName: (Home_module_default()).main,
        enableCompanySearch: true
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureFlagsContext/* FeatureFlagsProvider */.O, {
        featureFlags: featureFlags,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AppContext/* AppProvider */.wI, {
            ...initialAppParams,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                    title: `${company.name} Jobs and Company Culture | The Muse`,
                    description: company.description,
                    canonical: `${museWebHost}/profiles/${company.short_name}`,
                    openGraph: {
                        url: `${museWebHost}/profiles/${company.short_name}`,
                        title: `${company.name} Jobs and Company Culture | The Muse`,
                        description: company.description,
                        siteName: "The Muse",
                        images: [
                            {
                                url: "https://www.themuse.com/static/images/muse-og-image.png",
                                width: 400,
                                height: 400,
                                alt: "The Muse Logo",
                                type: "image/jpeg"
                            }
                        ]
                    },
                    additionalMetaTags: [
                        {
                            property: "msvalidate.01",
                            content: "4115DAD7B842017BA77853D5654B5CB0"
                        },
                        {
                            name: "p:domain_verify",
                            content: "09380361cb040eec0860a103a9c11da2"
                        }
                    ],
                    twitter: {
                        handle: "@TheMuse",
                        site: "@TheMuse",
                        cardType: "summary_large_image"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* LocalBusinessJsonLd */.wq, {
                    type: "LocalBusiness",
                    id: `${museWebHost}/profiles/${company.short_name}`,
                    name: company.name,
                    description: company.description,
                    url: `${museWebHost}/profiles/${company.short_name}`,
                    address: null,
                    images: [
                        company.snapshot_photo,
                        company.logo, 
                    ],
                    numberOfEmployees: company?.employee_range?.split("_")?.shift() ?? "unknown"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(UserProvider, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserInit, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SnowPlowInit, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyPage, {
                                ...pageLayoutProps
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var __N_SSP = true;
/* harmony default export */ var pages = (Home);


/***/ }),

/***/ 2918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "aO": function() { return /* binding */ formatCardDate; },
/* harmony export */   "z_": function() { return /* binding */ joinExisting; }
/* harmony export */ });
/* unused harmony exports formatNumberComma, isTruthy */
/**
 * Convert number to string and add a comma for thousands and millions.
 */ const formatNumberComma = (value)=>new Intl.NumberFormat("en-US").format(value);
/**
 * Formats a date in the numeric US format (6/21/2003).
 */ const formatCardDate = (date)=>{
    const intlDateString = new Intl.DateTimeFormat("en-us", {
        month: "short",
        year: "2-digit"
    });
    return intlDateString.format(date).toString();
};
/**
 * Returns true if the param is truthy or the string true.
 */ const isTruthy = (string)=>/^(true|1)$/.test(string.toLowerCase());
/**
 * Returns combined string of all existing values.
 */ const joinExisting = (strings, joiner = " ")=>strings.filter(Boolean).join(joiner);



/***/ }),

/***/ 5934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getPathParts; },
/* harmony export */   "s": function() { return /* binding */ setQueryParam; }
/* harmony export */ });
/**
 *  Takes relative pathname and splits into query, hash, and pathname with no hash/query
 */ const getPathParts = (relativePath = "")=>{
    const [basepath, hash] = relativePath.split("#");
    const [pathname, query] = basepath.split("?");
    return {
        pathname,
        hash,
        query
    };
};
/**
 *  Takes existing query string and sets or removes the param indicated
 */ const setQueryParam = ({ key , query , value  })=>{
    const params = new URLSearchParams(query || "");
    if (value === undefined) {
        params.delete(key);
    } else {
        params.set(key, value);
    }
    return params.toString();
};


/***/ }),

/***/ 8468:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"heading":"ArticleCardList_heading__H2MUh","cardList":"ArticleCardList_cardList__BSSJ1"};

/***/ }),

/***/ 2958:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"companyDetails":"CompanyDetails_companyDetails__3Blw2"};

/***/ }),

/***/ 7869:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contentWell":"ContentWell_contentWell__iJ2I_","headings":"ContentWell_headings__4z3ZP","contentBody":"ContentWell_contentBody__sBsKw","contentCardList":"ContentWell_contentCardList__9gh8_","viewMore":"ContentWell_viewMore__Gwu6W","viewMoreLink":"ContentWell_viewMoreLink__VbJDN"};

/***/ }),

/***/ 757:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"nav":"CulturesNav_nav__mtcWt","link":"CulturesNav_link__aeeDI","link--active":"CulturesNav_link--active__yTEab"};

/***/ }),

/***/ 38:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"figure":"EmployeeCard_figure__6mW9U","image":"EmployeeCard_image__JdAHC","figcap":"EmployeeCard_figcap__wTkUf","cta":"EmployeeCard_cta__jT31e","header":"EmployeeCard_header__QkFFE","title":"EmployeeCard_title__UMCww","subheading":"EmployeeCard_subheading__vhlyY","description":"EmployeeCard_description__8HAWH"};

/***/ }),

/***/ 9947:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Featured_wrapper__dnX25","wrapper--reverse":"Featured_wrapper--reverse__NdfRx","figure":"Featured_figure___qDaP","leaf":"Featured_leaf__rCubl","leaf--flipped":"Featured_leaf--flipped__efnqq","cta":"Featured_cta__BTyci","body":"Featured_body__vW8lH","quote":"Featured_quote__G0DWq"};

/***/ }),

/***/ 1951:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Hero_wrapper___jf9q","cta":"Hero_cta__e1cF9","body":"Hero_body__998fA","title":"Hero_title__vjHPu","subheading":"Hero_subheading__Xg_ck","description":"Hero_description__zTjE6"};

/***/ }),

/***/ 2579:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EmployeeCardList_wrapper__7XAHD","heading":"EmployeeCardList_heading__HYN1v","cardList":"EmployeeCardList_cardList__oiBwn"};

/***/ }),

/***/ 17:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dialog":"EmployeeStoryModal_dialog__o5_gM","modalClose":"EmployeeStoryModal_modalClose__IDbIJ","modalContent":"EmployeeStoryModal_modalContent__OrVwl","header":"EmployeeStoryModal_header__OvQQ7","portrait":"EmployeeStoryModal_portrait__S_uK4","portraitImg":"EmployeeStoryModal_portraitImg__1fWSl","portraitGraphic":"EmployeeStoryModal_portraitGraphic__8KcT6","headerContent":"EmployeeStoryModal_headerContent__r1T_8","title":"EmployeeStoryModal_title__Ot_oF","subheading":"EmployeeStoryModal_subheading__A4uD_","mainBody":"EmployeeStoryModal_mainBody__phBVo","overviewTitle":"EmployeeStoryModal_overviewTitle__3PszO","overviewText":"EmployeeStoryModal_overviewText__HDUBz","quote":"EmployeeStoryModal_quote__qiC_4"};

/***/ }),

/***/ 3803:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseGrid":"Hero_baseGrid__kPNXU","hero":"Hero_hero__YKQJz","heroGrid":"Hero_heroGrid__RjYVf Hero_baseGrid__kPNXU","heroImageWrapper":"Hero_heroImageWrapper__lz5C6","picture":"Hero_picture__ymsdb","heroImage":"Hero_heroImage__BmzKZ","heroContentWrapper":"Hero_heroContentWrapper__wIu74","title":"Hero_title__tlTad","logoWrapper":"Hero_logoWrapper__WWbXB","logo":"Hero_logo__Yv0ui","missingLogo":"Hero_missingLogo__xcJKR"};

/***/ }),

/***/ 6936:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"jobCardList":"JobCardList_jobCardList__Q57EX","searchButton":"JobCardList_searchButton__NRW4t","empty":"JobCardList_empty__cCrz7","folder":"JobCardList_folder__ohdOI","subtext":"JobCardList_subtext__VyL7p"};

/***/ }),

/***/ 4631:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"jobCardListItem":"JobCardListItem_jobCardListItem__zOJgs"};

/***/ }),

/***/ 9210:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"perks":"Perks_perks__gaDAT","perk":"Perks_perk__r5wdA"};

/***/ }),

/***/ 2703:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__CGPiT","description":"Sidebar_description___2PWl"};

/***/ }),

/***/ 7286:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseGrid":"TabMain_baseGrid__AUVY0","heading":"TabMain_heading__tArzs","cardList":"TabMain_cardList__XxIHw","tabMain":"TabMain_tabMain__IpaEg TabMain_baseGrid__AUVY0"};

/***/ }),

/***/ 4865:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"Home_main__zgAJj","pageHeader":"Home_pageHeader__Y8w6l","header":"Home_header__6KCIB","inputMenuOpen":"Home_inputMenuOpen__jnEXa","sidebar":"Home_sidebar__moo8u","showSidebar":"Home_showSidebar__I0bGu Home_sidebar__moo8u","content":"Home_content__f1lUf","filterToggle":"Home_filterToggle__N96mk"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [307,962,883,499,774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);